// This file is auto-generated by scripts/generate-property-metadata.ts
// Do not edit manually

import { registerGeneratedClassMetadata, registerGeneratedPropertyMetadata, registerGeneratedRpcMetadata } from './utils/serialization/decorator.js';

import { Actor } from './actors/Actor.js';
import { ActorNetTransform, PawnNetTransform } from './actors/ActorNetworking.js';
import { CharacterPawn } from './actors/CharacterPawn.js';
import { GameSessionInfo } from './actors/GameSessionInfo.js';
import { Pawn } from './actors/Pawn.js';
import { PlayerController } from './actors/PlayerController.js';
import { PlayerInfo } from './actors/PlayerInfo.js';
import { Projectile } from './actors/Projectile.js';
import { AnimationConfigResource } from './animation/AnimationConfigResource.js';
import { CharacterStatsComponent } from './components/CharacterStatsComponent.js';
import { CollisionShapeComponent } from './components/CollisionShapeComponent.js';
import { FollowComponent } from './components/FollowComponent.js';
import { PrimitiveComponent } from './components/PrimitiveComponent.js';
import { ResetPositionComponent } from './components/ResetPositionComponent.js';
import { SceneComponent } from './components/SceneComponent.js';
import { ViewTargetCameraComponent } from './components/ViewTargetCameraComponent.js';
import { World } from './game/World.js';
import { NavigationSettings } from './navigation/NavigationSettings.js';
import { UrlTexture } from './render/Texture.js';
import { VFXDefinition, VFXEmitterSettings, VFXParticlesSettings } from './vfx/types.js';
import { VFXComponent } from './vfx/VFXComponent.js';
import { SoundComponent } from './components/audio/SoundComponent.js';
import { SoundResource } from './components/audio/SoundResource.js';
import { CSGCombiner } from './components/csg/CSGCombiner.js';
import { CSGComponent } from './components/csg/CSGComponent.js';
import { CSGCubeComponent } from './components/csg/CSGCubeComponent.js';
import { CSGCylinderComponent } from './components/csg/CSGCylinderComponent.js';
import { CSGSphereComponent } from './components/csg/CSGSphereComponent.js';
import { BaseWeaponComponent } from './components/gameplay/BaseWeaponComponent.js';
import { DoorComponent } from './components/gameplay/DoorComponent.js';
import { GenericEquipment } from './components/gameplay/GenericEquipment.js';
import { InstantHitWeaponComponent } from './components/gameplay/InstantHitWeaponComponent.js';
import { HealthPickupComponent, PickupComponent, PickupSpawnerComponent } from './components/gameplay/PickupComponent.js';
import { ProximityInteractableComponent } from './components/gameplay/ProximityInteractableComponent.js';
import { SwitchComponent } from './components/gameplay/SwitchComponent.js';
import { TriggerZoneComponent } from './components/gameplay/TriggerZoneComponent.js';
import { DirectionalLightComponent } from './components/lights/DirectionalLightComponent.js';
import { HemisphereLightComponent } from './components/lights/HemisphereLightComponent.js';
import { LightComponent } from './components/lights/LightComponent.js';
import { LightProbeGridComponent } from './components/lights/LightProbeGridComponent.js';
import { PointLightComponent } from './components/lights/PointLightComponent.js';
import { RectAreaLightComponent } from './components/lights/RectAreaLightComponent.js';
import { SpotLightComponent } from './components/lights/SpotLightComponent.js';
import { AerialMovementComponent } from './components/movement/AerialMovementComponent.js';
import { AirplaneMovementComponent } from './components/movement/AirplaneMovementComponent.js';
import { BasePawnMovementComponent } from './components/movement/BasePawnMovementComponent.js';
import { CharacterMovementComponent } from './components/movement/CharacterMovementComponent.js';
import { PathMovementComponent } from './components/movement/PathMovementComponent.js';
import { SpectatorMovementComponent } from './components/movement/SpectatorMovementComponent.js';
import { SpringArmComponent } from './components/movement/SpringArmComponent.js';
import { TopDownMovementComponent } from './components/movement/TopDownMovementComponent.js';
import { TweenMovementComponent } from './components/movement/TweenMovementComponent.js';
import { VehicleMovementComponent } from './components/movement/VehicleMovementComponent.js';
import { AnimationStateMachineComponent } from './components/visual/AnimationStateMachineComponent.js';
import { BaseInstancedMeshComponent } from './components/visual/BaseInstancedMeshComponent.js';
import { BillboardComponent } from './components/visual/BillboardComponent.js';
import { FogComponent } from './components/visual/FogComponent.js';
import { InstancedMeshComponent } from './components/visual/InstancedMeshComponent.js';
import { InstancedModelMeshComponent } from './components/visual/InstancedModelMeshComponent.js';
import { MeshComponent } from './components/visual/MeshComponent.js';
import { MeshSocket } from './components/visual/MeshSocket.js';
import { ModelMeshComponent } from './components/visual/ModelMeshComponent.js';
import { SceneEnvironmentComponent } from './components/visual/SceneEnvironmentComponent.js';
import { SkyComponent } from './components/visual/SkyComponent.js';
import { SplineMeshComponent } from './components/visual/SplineMeshComponent.js';
import { TerrainMeshComponent } from './components/visual/TerrainMeshComponent.js';
import { TextComponent } from './components/visual/TextComponent.js';
import { UI3DComponent } from './components/visual/UI3DComponent.js';
import { VoxelMeshComponent } from './components/voxel/VoxelMeshComponent.js';
import { BehaviorTreeComponent } from './npc/behavior-tree/BehaviorTreeComponent.js';
import { CanvasUIComponent } from './xr/actor-components/CanvasUIComponent.js';
import { VRGrabbableComponent } from './xr/actor-components/VRGrabbableComponent.js';
import { VRInteractableComponent } from './xr/actor-components/VRInteractableComponent.js';
import { VRInteractComponent } from './xr/pawn-components/VRInteractComponent.js';
import { VRSnapTurnComponent } from './xr/pawn-components/VRSnapTurnComponent.js';
import { VRTeleportComponent } from './xr/pawn-components/VRTeleportComponent.js';
import { ColorGradientNodeMaterialAsset } from './runtime/materials/nodeMaterialAssets/ColorGradientNodeMaterialAsset.js';
import { DissolveNodeMaterialAsset } from './runtime/materials/nodeMaterialAssets/DissolveNodeMaterialAsset.js';
import { FresnelRimNodeMaterialAsset } from './runtime/materials/nodeMaterialAssets/FresnelRimNodeMaterialAsset.js';
import { HeatDistortionNodeMaterialAsset } from './runtime/materials/nodeMaterialAssets/HeatDistortionNodeMaterialAsset.js';
import { IridescenceNodeMaterialAsset } from './runtime/materials/nodeMaterialAssets/IridescenceNodeMaterialAsset.js';
import { MeshBasicNodeMaterialAsset } from './runtime/materials/nodeMaterialAssets/MeshBasicNodeMaterialAsset.js';
import { MeshLambertNodeMaterialAsset } from './runtime/materials/nodeMaterialAssets/MeshLambertNodeMaterialAsset.js';
import { MeshMatcapNodeMaterialAsset } from './runtime/materials/nodeMaterialAssets/MeshMatcapNodeMaterialAsset.js';
import { MeshNormalNodeMaterialAsset } from './runtime/materials/nodeMaterialAssets/MeshNormalNodeMaterialAsset.js';
import { MeshPhongNodeMaterialAsset } from './runtime/materials/nodeMaterialAssets/MeshPhongNodeMaterialAsset.js';
import { MeshPhysicalNodeMaterialAsset } from './runtime/materials/nodeMaterialAssets/MeshPhysicalNodeMaterialAsset.js';
import { MeshStandardNodeMaterialAsset } from './runtime/materials/nodeMaterialAssets/MeshStandardNodeMaterialAsset.js';
import { MeshToonNodeMaterialAsset } from './runtime/materials/nodeMaterialAssets/MeshToonNodeMaterialAsset.js';
import { NeonPulseNodeMaterialAsset } from './runtime/materials/nodeMaterialAssets/NeonPulseNodeMaterialAsset.js';
import { ParallaxUVNodeMaterialAsset } from './runtime/materials/nodeMaterialAssets/ParallaxUVNodeMaterialAsset.js';
import { PointsNodeMaterialAsset } from './runtime/materials/nodeMaterialAssets/PointsNodeMaterialAsset.js';
import { SpriteNodeMaterialAsset } from './runtime/materials/nodeMaterialAssets/SpriteNodeMaterialAsset.js';
import { SSSNodeMaterialAsset } from './runtime/materials/nodeMaterialAssets/SSSNodeMaterialAsset.js';
import { TransmissionNodeMaterialAsset } from './runtime/materials/nodeMaterialAssets/TransmissionNodeMaterialAsset.js';
import { VertexWaveNodeMaterialAsset } from './runtime/materials/nodeMaterialAssets/VertexWaveNodeMaterialAsset.js';
import { WorldTriplanarNodeMaterialAsset } from './runtime/materials/nodeMaterialAssets/WorldTriplanarNodeMaterialAsset.js';

export function registerMetadata(): void {
  registerGeneratedPropertyMetadata(Actor, {
      "editorData": {
        "type": "unknown",
        "editorOnly": true,
        "hidden": true
      },
      "uuid": {
        "type": "string",
        "transientOnPrefab": true,
        "readonly": true,
        "order": -20
      },
      "name": {
        "type": "string",
        "order": -19,
        "hidden": true
      },
      "replicateTransform": {
        "type": "boolean",
        "category": "Multiplayer"
      },
      "netTransform": {
        "type": "object",
        "fields": {
          "position": {
            "type": "vector3",
            "replicate": true,
            "net": {
              "netType": "vector3",
              "quantization": {
                "mode": "scale",
                "scale": 1000
              }
            }
          },
          "rotation": {
            "type": "euler",
            "replicate": true,
            "net": {
              "netType": "euler",
              "quantization": {
                "mode": "range",
                "min": -3.141592653589793,
                "max": 3.141592653589793,
                "bits": 16
              }
            }
          },
          "scale": {
            "type": "vector3",
            "replicate": true,
            "net": {
              "netType": "vector3",
              "quantization": {
                "mode": "range",
                "min": 0.01,
                "max": 100,
                "bits": 12
              }
            }
          }
        },
        "replicate": true,
        "transient": true,
        "hidden": true,
        "net": {
          "netType": "struct",
          "replicateTo": "all",
          "structClass": ActorNetTransform
        }
      },
      "actorTags": {
        "type": "multiselect",
        "child": {
          "type": "string"
        },
        "options": [],
        "createNewAllowed": true,
        "placeholder": "Add tags...",
        "useDisplayCase": false,
        "description": "Actor tags for categorization and filtering",
        "order": -18
      },
      "hiddenInGame": {
        "type": "boolean",
        "category": "Advanced",
        "categoryOrder": 100
      },
      "editorOnly": {
        "type": "boolean",
        "category": "Advanced"
      },
      "replicated": {
        "type": "boolean",
        "category": "Multiplayer"
      },
      "netLocalRole": {
        "type": "enum",
        "options": [
          "None",
          "Authority",
          "AutonomousProxy",
          "SimulatedProxy"
        ],
        "replicate": true,
        "category": "Multiplayer",
        "net": {
          "netType": "enum",
          "replicateTo": "all",
          "enumOptions": [
            "None",
            "Authority",
            "AutonomousProxy",
            "SimulatedProxy"
          ]
        }
      },
      "netOwningClientId": {
        "type": "string",
        "hidden": true
      },
      "onlyRelevantToOwner": {
        "type": "boolean",
        "category": "Multiplayer"
      },
      "netRemoteRole": {
        "type": "enum",
        "options": [
          "None",
          "Authority",
          "AutonomousProxy",
          "SimulatedProxy"
        ],
        "replicate": true,
        "hidden": true,
        "transient": true,
        "net": {
          "netType": "enum",
          "replicateTo": "all",
          "enumOptions": [
            "None",
            "Authority",
            "AutonomousProxy",
            "SimulatedProxy"
          ]
        }
      }
    });

  registerGeneratedClassMetadata(ActorNetTransform, { description: "Replicated transform state for simple actors.\nUsed by {@link Actor.netTransform} when {@link Actor.replicateTransform} is `true`.\nCharacters should use {@link PawnNetTransform} instead." });
  registerGeneratedPropertyMetadata(ActorNetTransform, {
      "position": {
        "type": "vector3",
        "replicate": true,
        "net": {
          "netType": "vector3",
          "replicateTo": "all",
          "quantization": {
            "mode": "scale",
            "scale": 1000
          }
        }
      },
      "rotation": {
        "type": "euler",
        "replicate": true,
        "net": {
          "netType": "euler",
          "replicateTo": "all",
          "quantization": {
            "mode": "range",
            "min": -3.141592653589793,
            "max": 3.141592653589793,
            "bits": 16
          }
        }
      },
      "scale": {
        "type": "vector3",
        "replicate": true,
        "net": {
          "netType": "vector3",
          "replicateTo": "all",
          "quantization": {
            "mode": "range",
            "min": 0.01,
            "max": 100,
            "bits": 12
          }
        }
      }
    });

  registerGeneratedClassMetadata(PawnNetTransform, { description: "Replicated transform state for character actors (Pawn).\nExtends {@link ActorNetTransform} with a server-side timestamp required for\nmovement prediction and interpolation on clients." });
  registerGeneratedPropertyMetadata(PawnNetTransform, {
      "timestamp": {
        "type": "number",
        "replicate": true,
        "net": {
          "netType": "float",
          "replicateTo": "all",
          "quantization": {
            "mode": "scale",
            "scale": 1000
          }
        }
      }
    });

  registerGeneratedClassMetadata(CharacterPawn, { description: "This is a more opinionated pawn that provides a common setup for a pawn with camera, animation, and movement.\nYou can either use it as the base class, override the various setupXXX methods for customization,\nor use it as reference implementation to create your own class from scratch.\n\nThe default implementation setups a humanoid pawn (using engine assets) with a third person camera." });
  registerGeneratedPropertyMetadata(CharacterPawn, {
      "camera": {
        "type": "unknown",
        "hidden": true
      },
      "cameraPivot": {
        "type": "componentReference",
        "componentClass": "SceneComponent",
        "hidden": true
      },
      "springArm": {
        "type": "componentReference",
        "componentClass": "SpringArmComponent",
        "hidden": true
      },
      "visualComponent": {
        "type": "componentReference",
        "componentClass": "SceneComponent",
        "hidden": true
      },
      "animationComponent": {
        "type": "componentReference",
        "componentClass": "AnimationStateMachineComponent",
        "hidden": true
      },
      "cameraMinDistance": {
        "type": "number",
        "min": 0.5,
        "max": 10,
        "step": 0.1,
        "category": "Camera"
      },
      "cameraMaxDistance": {
        "type": "number",
        "min": 1,
        "max": 20,
        "step": 0.1,
        "category": "Camera"
      },
      "cameraZoomSensitivity": {
        "type": "number",
        "min": 0.1,
        "max": 2,
        "step": 0.1,
        "category": "Camera"
      },
      "cameraCollisionBuffer": {
        "type": "number",
        "min": 0,
        "max": 0.5,
        "step": 0.01,
        "category": "Camera"
      },
      "cameraSpringStiffness": {
        "type": "number",
        "min": 0.1,
        "max": 20,
        "step": 0.5,
        "category": "Camera"
      },
      "cameraMinPitchDegrees": {
        "type": "number",
        "min": -90,
        "max": 0,
        "step": 1,
        "category": "Camera"
      },
      "cameraMaxPitchDegrees": {
        "type": "number",
        "min": 0,
        "max": 90,
        "step": 1,
        "category": "Camera"
      }
    });

  registerGeneratedPropertyMetadata(GameSessionInfo, {
      "sessionState": {
        "type": "enum",
        "options": [
          "Initializing",
          "WaitingForPlayers",
          "Starting",
          "InProgress",
          "Ending",
          "Shutdown"
        ],
        "replicate": true,
        "net": {
          "netType": "enum",
          "replicateTo": "all",
          "enumOptions": [
            "Initializing",
            "WaitingForPlayers",
            "Starting",
            "InProgress",
            "Ending",
            "Shutdown"
          ]
        }
      },
      "playerCount": {
        "type": "number",
        "replicate": true,
        "net": {
          "netType": "uint",
          "replicateTo": "all"
        }
      },
      "maxPlayers": {
        "type": "number",
        "replicate": true,
        "net": {
          "netType": "uint",
          "replicateTo": "all"
        }
      },
      "countdown": {
        "type": "number",
        "replicate": true,
        "net": {
          "netType": "float",
          "nullable": true,
          "replicateTo": "all",
          "quantization": {
            "mode": "scale",
            "scale": 10
          }
        }
      }
    });

  registerGeneratedPropertyMetadata(Pawn, {
      "playerController": {
        "type": "actorReference",
        "actorClass": "PlayerController",
        "replicate": true,
        "hidden": true,
        "transient": true,
        "net": {
          "netType": "actorRef",
          "nullable": true,
          "replicateTo": "all"
        }
      },
      "pawnNetTransform": {
        "type": "object",
        "fields": {
          "timestamp": {
            "type": "number",
            "replicate": true,
            "net": {
              "netType": "float",
              "quantization": {
                "mode": "scale",
                "scale": 1000
              }
            }
          },
          "position": {
            "type": "vector3",
            "replicate": true,
            "net": {
              "netType": "vector3",
              "quantization": {
                "mode": "scale",
                "scale": 1000
              }
            }
          },
          "rotation": {
            "type": "euler",
            "replicate": true,
            "net": {
              "netType": "euler",
              "quantization": {
                "mode": "range",
                "min": -3.141592653589793,
                "max": 3.141592653589793,
                "bits": 16
              }
            }
          },
          "scale": {
            "type": "vector3",
            "replicate": true,
            "net": {
              "netType": "vector3",
              "quantization": {
                "mode": "range",
                "min": 0.01,
                "max": 100,
                "bits": 12
              }
            }
          }
        },
        "replicate": true,
        "transient": true,
        "hidden": true,
        "net": {
          "netType": "struct",
          "replicateTo": "all",
          "structClass": PawnNetTransform
        }
      },
      "enableDirectionalLightFollowing": {
        "type": "boolean"
      },
      "movementComponent": {
        "type": "componentReference",
        "componentClass": "BasePawnMovementComponent",
        "description": "The component that the pawn uses to move."
      }
    });

  registerGeneratedPropertyMetadata(PlayerController, {
      "pawn": {
        "type": "actorReference",
        "actorClass": "Pawn",
        "replicate": true,
        "hidden": true,
        "transient": true,
        "net": {
          "netType": "actorRef",
          "nullable": true,
          "replicateTo": "all"
        }
      },
      "playerInfo": {
        "type": "actorReference",
        "actorClass": "PlayerInfo",
        "replicate": true,
        "hidden": true,
        "transient": true,
        "net": {
          "netType": "actorRef",
          "nullable": true,
          "replicateTo": "all"
        }
      },
      "noPointerLock": {
        "type": "boolean"
      }
    });

  registerGeneratedPropertyMetadata(PlayerInfo, {
      "clientId": {
        "type": "string",
        "default": "",
        "replicate": true,
        "net": {
          "netType": "string",
          "replicateTo": "all"
        }
      },
      "playerName": {
        "type": "string",
        "default": "Player",
        "replicate": true,
        "net": {
          "netType": "string",
          "replicateTo": "all"
        }
      },
      "isReady": {
        "type": "boolean",
        "default": false,
        "replicate": true,
        "net": {
          "netType": "bool",
          "replicateTo": "all"
        }
      },
      "team": {
        "type": "string",
        "default": "",
        "replicate": true,
        "net": {
          "netType": "string",
          "replicateTo": "all"
        }
      },
      "score": {
        "type": "number",
        "default": 0,
        "replicate": true,
        "net": {
          "netType": "int",
          "replicateTo": "all"
        }
      },
      "ping": {
        "type": "number",
        "default": 0,
        "replicate": true,
        "net": {
          "netType": "uint",
          "replicateTo": "all"
        }
      },
      "isAlive": {
        "type": "boolean",
        "default": true,
        "replicate": true,
        "net": {
          "netType": "bool",
          "replicateTo": "all"
        }
      },
      "kills": {
        "type": "number",
        "default": 0,
        "replicate": true,
        "net": {
          "netType": "uint",
          "replicateTo": "all"
        }
      },
      "deaths": {
        "type": "number",
        "default": 0,
        "replicate": true,
        "net": {
          "netType": "uint",
          "replicateTo": "all"
        }
      }
    });

  registerGeneratedPropertyMetadata(Projectile, {
      "damageDealt": {
        "type": "number"
      },
      "destroyOnHit": {
        "type": "boolean"
      },
      "gravityScale": {
        "type": "number"
      },
      "useOverlapCheck": {
        "type": "boolean"
      },
      "range": {
        "type": "number"
      },
      "geometry": {
        "type": "bufferGeometry"
      },
      "material": {
        "type": "class"
      },
      "projectileLifespan": {
        "type": "number"
      }
    });

  registerGeneratedPropertyMetadata(AnimationConfigResource, {
      "autoPlay": {
        "type": "boolean"
      },
      "parameters": {
        "type": "unknown"
      },
      "states": {
        "type": "unknown"
      },
      "initialState": {
        "type": "string",
        "required": true
      },
      "clipOptions": {
        "type": "unknown"
      },
      "oneShotClips": {
        "type": "array",
        "child": {
          "type": "string"
        }
      },
      "masks": {
        "type": "unknown"
      },
      "layer": {
        "type": "object",
        "fields": {
          "id": {
            "type": "string"
          },
          "mode": {
            "type": "enum",
            "options": [
              "additive",
              "override"
            ]
          },
          "include": {
            "type": "array",
            "child": {
              "type": "string"
            }
          },
          "selectorType": {
            "type": "enum",
            "options": [
              "bone",
              "role"
            ]
          },
          "mask": {
            "type": "string"
          },
          "enabled": {
            "type": "boolean"
          },
          "weight": {
            "type": "number"
          },
          "states": {
            "type": "unknown"
          },
          "initialState": {
            "type": "string"
          }
        }
      },
      "events": {
        "type": "unknown"
      },
      "externalAnimationSources": {
        "type": "array"
      },
      "targetSkeletonProfile": {
        "type": "string"
      }
    });

  registerGeneratedPropertyMetadata(CharacterStatsComponent, {
      "maxHealth": {
        "type": "number",
        "min": 1,
        "step": 1,
        "decimals": 0,
        "description": "Maximum health points"
      },
      "healthRegen": {
        "type": "number",
        "min": 0,
        "step": 0.1,
        "decimals": 1,
        "description": "Health regeneration per second"
      },
      "attackCooldown": {
        "type": "number",
        "min": 0,
        "step": 0.1,
        "decimals": 1,
        "description": "Cooldown between attacks in seconds"
      },
      "attackRange": {
        "type": "number",
        "min": 0,
        "step": 0.1,
        "decimals": 1,
        "description": "Attack range in units"
      },
      "attackDamage": {
        "type": "number",
        "min": 0,
        "step": 1,
        "decimals": 0,
        "description": "Damage dealt per attack"
      },
      "speed": {
        "type": "number",
        "min": 0,
        "step": 0.1,
        "decimals": 1,
        "description": "Movement speed in units per second"
      }
    });

  registerGeneratedClassMetadata(CollisionShapeComponent, { description: "Component that adds collision detection capability to an actor.\nCreates invisible collision geometry for physics interaction.\nThe collision shape size is controlled by the component's transform scale." });
  registerGeneratedPropertyMetadata(CollisionShapeComponent, {
      "enableDebugVisualization": {
        "type": "boolean"
      }
    });

  registerGeneratedClassMetadata(FollowComponent, { description: "Component that makes its owner follow another scene component\nwith configurable damping and rotation axis control" });
  registerGeneratedPropertyMetadata(FollowComponent, {
      "target": {
        "type": "componentReference",
        "componentClass": "SceneComponent"
      },
      "positionDamping": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.01,
        "decimals": 2,
        "description": "Position damping factor (0-1)"
      },
      "useCameraLookAtConvention": {
        "type": "boolean",
        "description": "Use camera look at convention"
      },
      "positionOffset": {
        "type": "vector3",
        "description": "Offset from target position"
      },
      "lookAtOffset": {
        "type": "vector3",
        "description": "Offset from target position to look at"
      }
    });

  registerGeneratedClassMetadata(PrimitiveComponent, { description: "PrimitiveComponents are SceneComponents that contain or generate geometry for rendering or collision.\nSubclasses: MeshComponent (GLTF, Instanced), CollisionShapeComponent, VoxelMeshComponent, TerrainMeshComponent.\nCollision-related functionality will be moved here from SceneComponent (only primitives participate in collision)." });
  registerGeneratedPropertyMetadata(PrimitiveComponent, {
      "physicsOptions": {
        "type": "object",
        "fields": {
          "enabled": {
            "type": "boolean"
          },
          "motionType": {
            "type": "enum",
            "options": [
              "static",
              "kinematicVelocityBased",
              "kinematicPositionBased",
              "dynamic"
            ]
          },
          "density": {
            "type": "number"
          },
          "ignoreForInputCollision": {
            "type": "boolean"
          },
          "generateCollisionEvents": {
            "type": "boolean"
          },
          "gravityScale": {
            "type": "number"
          },
          "collisionMeshType": {
            "type": "enum",
            "options": [
              "boundingBox",
              "boundingSphere",
              "convexHull",
              "trimesh",
              "voxels"
            ]
          },
          "collisionData": {
            "type": "object",
            "fields": {
              "voxels": {
                "type": "object",
                "fields": {
                  "voxelSize": {
                    "type": "vector3"
                  },
                  "offset": {
                    "type": "vector3"
                  }
                }
              },
              "heightfield": {
                "type": "object",
                "fields": {
                  "width": {
                    "type": "number"
                  },
                  "depth": {
                    "type": "number"
                  },
                  "widthPixels": {
                    "type": "number"
                  },
                  "depthPixels": {
                    "type": "number"
                  },
                  "maxHeight": {
                    "type": "number"
                  },
                  "heightEncoding": {
                    "type": "enum",
                    "options": [
                      "worldY",
                      "normalizedCentered"
                    ]
                  },
                  "colliderRotationCorrection": {
                    "type": "quaternion"
                  }
                }
              }
            }
          },
          "enableCCD": {
            "type": "boolean"
          },
          "collisionProfile": {
            "type": "enum",
            "options": [
              "NoCollision",
              "BlockAll",
              "OverlapAll",
              "BlockAllDynamic",
              "OverlapAllDynamic",
              "IgnoreOnlyPawns",
              "Pawn",
              "Character",
              "Destructible",
              "InvisibleWall",
              "InvisibleWallDynamic",
              "Trigger",
              "Ragdoll",
              "Vehicle",
              "UI",
              "SpringArmCamera"
            ]
          }
        }
      },
      "navigationGeometryRole": {
        "type": "enum",
        "options": [
          "walkable",
          "obstacle",
          "exclude"
        ],
        "description": "Walkable contributes floor surfaces. Obstacle blocks paths but is never walkable. Exclude omits geometry from the bake."
      },
      "excludeFromNavigation": {
        "type": "boolean",
        "hidden": true,
        "description": "Legacy. Use navigationGeometryRole instead."
      }
    });

  registerGeneratedClassMetadata(ResetPositionComponent, { description: "Component that resets an object's position when it falls below a certain threshold" });
  registerGeneratedPropertyMetadata(ResetPositionComponent, {
      "resetPosition": {
        "type": "vector3",
        "description": "The position to reset to when fallen"
      },
      "fallThreshold": {
        "type": "number",
        "step": 1,
        "decimals": 0,
        "description": "Y-coordinate threshold for reset"
      },
      "resetVelocities": {
        "type": "boolean",
        "description": "Whether to reset velocities when teleporting"
      }
    });

  registerGeneratedPropertyMetadata(SceneComponent, {
      "editorData": {
        "type": "unknown",
        "editorOnly": true,
        "hidden": true
      },
      "prefabNodeId": {
        "type": "string",
        "hidden": true,
        "alwaysSerializeWhenSet": true
      },
      "hiddenInGame": {
        "type": "boolean",
        "category": "Advanced",
        "categoryOrder": 100
      },
      "editorOnly": {
        "type": "boolean",
        "category": "Advanced"
      },
      "replicated": {
        "type": "boolean"
      },
      "name": {
        "type": "string",
        "hidden": true
      },
      "position": {
        "type": "vector3",
        "decimals": 3,
        "order": -10
      },
      "rotation": {
        "type": "euler",
        "decimals": 1
      },
      "scale": {
        "type": "vector3",
        "decimals": 3,
        "showLinking": true
      },
      "visible": {
        "type": "boolean"
      },
      "castShadow": {
        "type": "boolean"
      },
      "receiveShadow": {
        "type": "boolean"
      },
      "static": {
        "type": "boolean"
      },
      "selfHidden": {
        "type": "boolean"
      }
    });

  registerGeneratedPropertyMetadata(ViewTargetCameraComponent, {
      "fov": {
        "type": "number"
      },
      "aspect": {
        "type": "number"
      },
      "near": {
        "type": "number"
      },
      "far": {
        "type": "number"
      },
      "startActive": {
        "type": "boolean"
      },
      "camera": {
        "type": "unknown"
      }
    });

  registerGeneratedPropertyMetadata(World, {
      "gameModeClass": {
        "type": "spawnable",
        "spawnableClass": "GameMode",
        "description": "The game mode class to use for this world"
      }
    });

  registerGeneratedClassMetadata(NavigationSettings, { description: "Persisted Recast navmesh generation parameters for a scene." });
  registerGeneratedPropertyMetadata(NavigationSettings, {
      "cellSize": {
        "type": "number"
      },
      "cellHeight": {
        "type": "number"
      },
      "walkableSlopeAngle": {
        "type": "number"
      },
      "walkableHeight": {
        "type": "number"
      },
      "walkableClimb": {
        "type": "number"
      },
      "walkableRadius": {
        "type": "number"
      },
      "maxEdgeLength": {
        "type": "number",
        "category": "Advanced"
      },
      "maxSimplificationError": {
        "type": "number",
        "category": "Advanced"
      },
      "minRegionArea": {
        "type": "number",
        "category": "Advanced"
      },
      "mergeRegionArea": {
        "type": "number",
        "category": "Advanced"
      },
      "maxVertsPerPoly": {
        "type": "number",
        "category": "Advanced"
      },
      "detailSampleDist": {
        "type": "number",
        "category": "Advanced"
      },
      "detailSampleMaxError": {
        "type": "number",
        "category": "Advanced"
      },
      "borderSize": {
        "type": "number",
        "category": "Advanced"
      }
    });

  registerGeneratedClassMetadata(UrlTexture, { description: "A texture that loads from a URL" });
  registerGeneratedPropertyMetadata(UrlTexture, {
      "url": {
        "type": "texturePath"
      }
    });

  registerGeneratedClassMetadata(VFXParticlesSettings, { description: "JSON schema for VFXParticles settings" });
  registerGeneratedPropertyMetadata(VFXParticlesSettings, {
      "nbParticles": {
        "type": "number"
      },
      "intensity": {
        "type": "number"
      },
      "renderMode": {
        "type": "enum",
        "options": [
          "stretchBillboard",
          "billboard",
          "mesh"
        ]
      },
      "stretchScale": {
        "type": "number"
      },
      "fadeSize": {
        "type": "array",
        "minLength": 2,
        "maxLength": 2,
        "child": {
          "type": "number"
        }
      },
      "fadeAlpha": {
        "type": "array",
        "minLength": 2,
        "maxLength": 2,
        "child": {
          "type": "number"
        }
      },
      "gravity": {
        "type": "array",
        "minLength": 3,
        "maxLength": 3,
        "child": {
          "type": "number"
        }
      },
      "appearance": {
        "type": "enum",
        "options": [
          "square",
          "circular"
        ]
      },
      "easeFunction": {
        "type": "enum",
        "options": [
          "easeLinear",
          "easeInPower1",
          "easeOutPower1",
          "easeInOutPower1",
          "easeInPower2",
          "easeOutPower2",
          "easeInOutPower2",
          "easeInPower3",
          "easeOutPower3",
          "easeInOutPower3",
          "easeInPower4",
          "easeOutPower4",
          "easeInOutPower4",
          "easeInQuad",
          "easeOutQuad",
          "easeInOutQuad",
          "easeInCubic",
          "easeOutCubic",
          "easeInOutCubic",
          "easeInQuart",
          "easeOutQuart",
          "easeInOutQuart",
          "easeInQuint",
          "easeOutQuint",
          "easeInOutQuint",
          "easeInSine",
          "easeOutSine",
          "easeInOutSine",
          "easeInExpo",
          "easeOutExpo",
          "easeInOutExpo",
          "easeInCirc",
          "easeOutCirc",
          "easeInOutCirc",
          "easeInElastic",
          "easeOutElastic",
          "easeInOutElastic",
          "easeInBack",
          "easeOutBack",
          "easeInOutBack",
          "easeInBounce",
          "easeOutBounce",
          "easeInOutBounce"
        ]
      },
      "blendingMode": {
        "type": "enum",
        "options": [
          "additive",
          "normal",
          "subtractive",
          "multiply"
        ]
      },
      "alphaMapPath": {
        "type": "string"
      },
      "geometryPath": {
        "type": "string"
      },
      "shadingHooks": {
        "type": "object",
        "fields": {
          "customUniforms": {
            "type": "string"
          },
          "customVaryings": {
            "type": "string"
          },
          "vertexBeforeMain": {
            "type": "string"
          },
          "vertexBeforeOutput": {
            "type": "string"
          },
          "fragmentBeforeMain": {
            "type": "string"
          },
          "fragmentBeforeOutput": {
            "type": "string"
          }
        }
      },
      "depthTest": {
        "type": "boolean"
      }
    });

  registerGeneratedClassMetadata(VFXEmitterSettings, { description: "JSON schema for VFXEmitter settings" });
  registerGeneratedPropertyMetadata(VFXEmitterSettings, {
      "particlesIndex": {
        "type": "number"
      },
      "loop": {
        "type": "boolean"
      },
      "duration": {
        "type": "number"
      },
      "nbParticles": {
        "type": "number"
      },
      "spawnMode": {
        "type": "enum",
        "options": [
          "time",
          "burst"
        ]
      },
      "delay": {
        "type": "number"
      },
      "particlesLifetime": {
        "type": "array",
        "minLength": 2,
        "maxLength": 2,
        "child": {
          "type": "number"
        }
      },
      "startPositionMin": {
        "type": "array",
        "minLength": 3,
        "maxLength": 3,
        "child": {
          "type": "number"
        }
      },
      "startPositionMax": {
        "type": "array",
        "minLength": 3,
        "maxLength": 3,
        "child": {
          "type": "number"
        }
      },
      "startRotationMin": {
        "type": "array",
        "minLength": 3,
        "maxLength": 3,
        "child": {
          "type": "number"
        }
      },
      "startRotationMax": {
        "type": "array",
        "minLength": 3,
        "maxLength": 3,
        "child": {
          "type": "number"
        }
      },
      "rotationSpeedMin": {
        "type": "array",
        "minLength": 3,
        "maxLength": 3,
        "child": {
          "type": "number"
        }
      },
      "rotationSpeedMax": {
        "type": "array",
        "minLength": 3,
        "maxLength": 3,
        "child": {
          "type": "number"
        }
      },
      "directionMin": {
        "type": "array",
        "minLength": 3,
        "maxLength": 3,
        "child": {
          "type": "number"
        }
      },
      "directionMax": {
        "type": "array",
        "minLength": 3,
        "maxLength": 3,
        "child": {
          "type": "number"
        }
      },
      "size": {
        "type": "array",
        "minLength": 2,
        "maxLength": 2,
        "child": {
          "type": "number"
        }
      },
      "speed": {
        "type": "array",
        "minLength": 2,
        "maxLength": 2,
        "child": {
          "type": "number"
        }
      },
      "colorStart": {
        "type": "array",
        "child": {
          "type": "string"
        }
      },
      "colorEnd": {
        "type": "array",
        "child": {
          "type": "string"
        }
      },
      "useLocalDirection": {
        "type": "boolean"
      }
    });

  registerGeneratedClassMetadata(VFXDefinition, { description: "Complete VFX definition with versioning and serialization" });
  registerGeneratedPropertyMetadata(VFXDefinition, {
      "version": {
        "type": "number"
      },
      "name": {
        "type": "string"
      },
      "particles": {
        "type": "array",
        "child": {
          "type": "object",
          "fields": {
            "nbParticles": {
              "type": "number"
            },
            "intensity": {
              "type": "number"
            },
            "renderMode": {
              "type": "enum",
              "options": [
                "stretchBillboard",
                "billboard",
                "mesh"
              ]
            },
            "stretchScale": {
              "type": "number"
            },
            "fadeSize": {
              "type": "array",
              "minLength": 2,
              "maxLength": 2,
              "child": {
                "type": "number"
              }
            },
            "fadeAlpha": {
              "type": "array",
              "minLength": 2,
              "maxLength": 2,
              "child": {
                "type": "number"
              }
            },
            "gravity": {
              "type": "array",
              "minLength": 3,
              "maxLength": 3,
              "child": {
                "type": "number"
              }
            },
            "appearance": {
              "type": "enum",
              "options": [
                "square",
                "circular"
              ]
            },
            "easeFunction": {
              "type": "enum",
              "options": [
                "easeLinear",
                "easeInPower1",
                "easeOutPower1",
                "easeInOutPower1",
                "easeInPower2",
                "easeOutPower2",
                "easeInOutPower2",
                "easeInPower3",
                "easeOutPower3",
                "easeInOutPower3",
                "easeInPower4",
                "easeOutPower4",
                "easeInOutPower4",
                "easeInQuad",
                "easeOutQuad",
                "easeInOutQuad",
                "easeInCubic",
                "easeOutCubic",
                "easeInOutCubic",
                "easeInQuart",
                "easeOutQuart",
                "easeInOutQuart",
                "easeInQuint",
                "easeOutQuint",
                "easeInOutQuint",
                "easeInSine",
                "easeOutSine",
                "easeInOutSine",
                "easeInExpo",
                "easeOutExpo",
                "easeInOutExpo",
                "easeInCirc",
                "easeOutCirc",
                "easeInOutCirc",
                "easeInElastic",
                "easeOutElastic",
                "easeInOutElastic",
                "easeInBack",
                "easeOutBack",
                "easeInOutBack",
                "easeInBounce",
                "easeOutBounce",
                "easeInOutBounce"
              ]
            },
            "blendingMode": {
              "type": "enum",
              "options": [
                "additive",
                "normal",
                "subtractive",
                "multiply"
              ]
            },
            "alphaMapPath": {
              "type": "string"
            },
            "geometryPath": {
              "type": "string"
            },
            "shadingHooks": {
              "type": "object",
              "fields": {
                "customUniforms": {
                  "type": "string"
                },
                "customVaryings": {
                  "type": "string"
                },
                "vertexBeforeMain": {
                  "type": "string"
                },
                "vertexBeforeOutput": {
                  "type": "string"
                },
                "fragmentBeforeMain": {
                  "type": "string"
                },
                "fragmentBeforeOutput": {
                  "type": "string"
                }
              }
            },
            "side": {
              "type": "enum",
              "options": [
                "0",
                "2",
                "1"
              ]
            },
            "depthTest": {
              "type": "boolean"
            }
          }
        }
      },
      "emitters": {
        "type": "array",
        "child": {
          "type": "object",
          "fields": {
            "particlesIndex": {
              "type": "number"
            },
            "loop": {
              "type": "boolean"
            },
            "duration": {
              "type": "number"
            },
            "nbParticles": {
              "type": "number"
            },
            "spawnMode": {
              "type": "enum",
              "options": [
                "time",
                "burst"
              ]
            },
            "delay": {
              "type": "number"
            },
            "particlesLifetime": {
              "type": "array",
              "minLength": 2,
              "maxLength": 2,
              "child": {
                "type": "number"
              }
            },
            "startPositionMin": {
              "type": "array",
              "minLength": 3,
              "maxLength": 3,
              "child": {
                "type": "number"
              }
            },
            "startPositionMax": {
              "type": "array",
              "minLength": 3,
              "maxLength": 3,
              "child": {
                "type": "number"
              }
            },
            "startRotationMin": {
              "type": "array",
              "minLength": 3,
              "maxLength": 3,
              "child": {
                "type": "number"
              }
            },
            "startRotationMax": {
              "type": "array",
              "minLength": 3,
              "maxLength": 3,
              "child": {
                "type": "number"
              }
            },
            "rotationSpeedMin": {
              "type": "array",
              "minLength": 3,
              "maxLength": 3,
              "child": {
                "type": "number"
              }
            },
            "rotationSpeedMax": {
              "type": "array",
              "minLength": 3,
              "maxLength": 3,
              "child": {
                "type": "number"
              }
            },
            "directionMin": {
              "type": "array",
              "minLength": 3,
              "maxLength": 3,
              "child": {
                "type": "number"
              }
            },
            "directionMax": {
              "type": "array",
              "minLength": 3,
              "maxLength": 3,
              "child": {
                "type": "number"
              }
            },
            "size": {
              "type": "array",
              "minLength": 2,
              "maxLength": 2,
              "child": {
                "type": "number"
              }
            },
            "speed": {
              "type": "array",
              "minLength": 2,
              "maxLength": 2,
              "child": {
                "type": "number"
              }
            },
            "colorStart": {
              "type": "array",
              "child": {
                "type": "string"
              }
            },
            "colorEnd": {
              "type": "array",
              "child": {
                "type": "string"
              }
            },
            "useLocalDirection": {
              "type": "boolean"
            }
          }
        }
      }
    });

  registerGeneratedPropertyMetadata(VFXComponent, {
      "vfxPath": {
        "type": "vfxPath"
      },
      "autoStart": {
        "type": "boolean"
      },
      "vfxEmitters": {
        "type": "array",
        "child": {
          "type": "unknown"
        },
        "hidden": true,
        "transient": true
      }
    });

  registerGeneratedPropertyMetadata(SoundComponent, {
      "soundResources": {
        "type": "array",
        "child": {
          "type": "resource",
          "resourceType": "SoundResource"
        }
      },
      "loop": {
        "type": "boolean"
      },
      "positional": {
        "type": "boolean"
      },
      "autoPlay": {
        "type": "boolean"
      },
      "autoPlayClipKey": {
        "type": "string"
      },
      "bus": {
        "type": "string"
      }
    });

  registerGeneratedPropertyMetadata(SoundResource, {
      "name": {
        "type": "string"
      },
      "audioPath": {
        "type": "audioPath",
        "required": true,
        "description": "Audio file path"
      },
      "volume": {
        "type": "number"
      },
      "refDistance": {
        "type": "number",
        "category": "Spatial"
      },
      "maxDistance": {
        "type": "number",
        "category": "Spatial"
      },
      "distanceModel": {
        "type": "enum",
        "options": [
          "linear",
          "inverse",
          "exponential"
        ],
        "category": "Spatial"
      },
      "rolloffFactor": {
        "type": "number",
        "category": "Spatial"
      }
    });

  registerGeneratedClassMetadata(CSGCombiner, { description: "Empty CSGComponent that acts as a CSG root. Owns the generated result mesh." });
  registerGeneratedPropertyMetadata(CSGCombiner, {
      "physicsOptions": {
        "type": "object",
        "fields": {
          "enabled": {
            "type": "boolean"
          },
          "motionType": {
            "type": "enum",
            "options": [
              "static",
              "kinematicVelocityBased",
              "kinematicPositionBased",
              "dynamic"
            ]
          },
          "density": {
            "type": "number"
          },
          "ignoreForInputCollision": {
            "type": "boolean"
          },
          "generateCollisionEvents": {
            "type": "boolean"
          },
          "gravityScale": {
            "type": "number"
          },
          "collisionMeshType": {
            "type": "enum",
            "options": [
              "boundingBox",
              "boundingSphere",
              "convexHull",
              "trimesh",
              "voxels"
            ]
          },
          "collisionData": {
            "type": "object",
            "fields": {
              "voxels": {
                "type": "object",
                "fields": {
                  "voxelSize": {
                    "type": "vector3"
                  },
                  "offset": {
                    "type": "vector3"
                  }
                }
              },
              "heightfield": {
                "type": "object",
                "fields": {
                  "width": {
                    "type": "number"
                  },
                  "depth": {
                    "type": "number"
                  },
                  "widthPixels": {
                    "type": "number"
                  },
                  "depthPixels": {
                    "type": "number"
                  },
                  "maxHeight": {
                    "type": "number"
                  },
                  "heightEncoding": {
                    "type": "enum",
                    "options": [
                      "worldY",
                      "normalizedCentered"
                    ]
                  },
                  "colliderRotationCorrection": {
                    "type": "quaternion"
                  }
                }
              }
            }
          },
          "enableCCD": {
            "type": "boolean"
          },
          "collisionProfile": {
            "type": "enum",
            "options": [
              "NoCollision",
              "BlockAll",
              "OverlapAll",
              "BlockAllDynamic",
              "OverlapAllDynamic",
              "IgnoreOnlyPawns",
              "Pawn",
              "Character",
              "Destructible",
              "InvisibleWall",
              "InvisibleWallDynamic",
              "Trigger",
              "Ragdoll",
              "Vehicle",
              "UI",
              "SpringArmCamera"
            ]
          }
        },
        "hidden": true
      }
    });

  registerGeneratedClassMetadata(CSGComponent, { description: "CSGComponent represents a CSG shape node that can both contribute a shape to\na parent CSGComponent and act as a root that processes its own children.\n\nAs a root it owns the generated `THREE.Mesh` directly (no separate\nMeshComponent). As a child it exposes `createManifold` so its parent can\nincorporate its geometry via a boolean operation.\n\nAbstract base class — extend this to create concrete shape types." });
  registerGeneratedPropertyMetadata(CSGComponent, {
      "operation": {
        "type": "enum",
        "options": [
          "add",
          "subtract",
          "intersect"
        ],
        "category": "CSG",
        "description": "Boolean operation type"
      },
      "materialUrl": {
        "type": "materialPath",
        "category": "CSG",
        "description": "Material for the CSG shape"
      }
    });

  registerGeneratedClassMetadata(CSGCubeComponent, { description: "Cube shape for CSG operations." });
  registerGeneratedPropertyMetadata(CSGCubeComponent, {
      "dimensions": {
        "type": "vector3",
        "category": "CSG",
        "description": "Dimensions of the cube"
      },
      "centered": {
        "type": "boolean",
        "category": "CSG",
        "description": "Whether the cube is centered at origin"
      }
    });

  registerGeneratedClassMetadata(CSGCylinderComponent, { description: "Cylinder shape for CSG operations." });
  registerGeneratedPropertyMetadata(CSGCylinderComponent, {
      "height": {
        "type": "number",
        "category": "CSG",
        "min": 0.01,
        "step": 0.1,
        "decimals": 2,
        "description": "Height of the cylinder"
      },
      "radiusBottom": {
        "type": "number",
        "category": "CSG",
        "min": 0.01,
        "step": 0.1,
        "decimals": 2,
        "description": "Radius at the bottom"
      },
      "radiusTop": {
        "type": "number",
        "category": "CSG",
        "min": 0.01,
        "step": 0.1,
        "decimals": 2,
        "description": "Radius at the top"
      },
      "segments": {
        "type": "number",
        "category": "CSG",
        "min": 3,
        "max": 128,
        "step": 1,
        "decimals": 0,
        "description": "Number of segments"
      },
      "centered": {
        "type": "boolean",
        "category": "CSG",
        "description": "Whether the cylinder is centered at origin"
      }
    });

  registerGeneratedClassMetadata(CSGSphereComponent, { description: "Sphere shape for CSG operations." });
  registerGeneratedPropertyMetadata(CSGSphereComponent, {
      "radius": {
        "type": "number",
        "category": "CSG",
        "min": 0.01,
        "step": 0.1,
        "decimals": 2,
        "description": "Radius of the sphere"
      },
      "segments": {
        "type": "number",
        "category": "CSG",
        "min": 3,
        "max": 128,
        "step": 1,
        "decimals": 0,
        "description": "Number of segments"
      }
    });

  registerGeneratedPropertyMetadata(BaseWeaponComponent, {
      "modelPath": {
        "type": "modelPath"
      },
      "ammoCapacity": {
        "type": "number",
        "min": 0,
        "step": 1,
        "decimals": 0
      },
      "reloadTime": {
        "type": "number",
        "min": 0,
        "step": 0.1,
        "decimals": 1
      },
      "fireSoundUrl": {
        "type": "audioPath"
      },
      "emptyFireSoundUrl": {
        "type": "audioPath"
      },
      "reloadSoundUrl": {
        "type": "audioPath"
      },
      "range": {
        "type": "number",
        "min": 0,
        "step": 10,
        "decimals": 0
      }
    });

  registerGeneratedPropertyMetadata(DoorComponent, {
      "doorType": {
        "type": "enum",
        "options": [
          "hinged",
          "sliding",
          "garage",
          "double",
          "custom"
        ]
      },
      "interactionType": {
        "type": "enum",
        "options": [
          "proximity",
          "keypress",
          "remote"
        ]
      },
      "animationDuration": {
        "type": "number",
        "min": 0.1,
        "step": 0.1,
        "decimals": 1,
        "description": "Animation duration in seconds"
      },
      "maxOpenAngle": {
        "type": "number",
        "min": 0,
        "max": 180,
        "step": 1,
        "decimals": 0,
        "description": "Maximum open angle for hinged doors (degrees)"
      },
      "slideDistance": {
        "type": "number",
        "min": 0,
        "step": 0.1,
        "decimals": 1,
        "description": "Slide distance for sliding doors"
      },
      "slideDirection": {
        "type": "vector3",
        "description": "Direction vector for sliding doors in local space"
      },
      "startLocked": {
        "type": "boolean",
        "description": "Whether the door starts in locked state"
      }
    });

  registerGeneratedPropertyMetadata(GenericEquipment, {
      "fireInterval": {
        "type": "number",
        "min": 0.01,
        "step": 0.1,
        "decimals": 2
      },
      "isSingleFire": {
        "type": "boolean"
      }
    });

  registerGeneratedPropertyMetadata(InstantHitWeaponComponent, {
      "damage": {
        "type": "number",
        "min": 0,
        "step": 1,
        "decimals": 0
      },
      "spread": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.01,
        "decimals": 3
      }
    });

  registerGeneratedPropertyMetadata(PickupComponent, {
      "pickupSoundUrl": {
        "type": "string",
        "description": "URL to the pickup sound file"
      },
      "pickupVolume": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.1,
        "decimals": 2,
        "description": "Volume of the pickup sound"
      },
      "pickupMaxDistance": {
        "type": "number",
        "min": 0,
        "step": 1,
        "decimals": 0,
        "description": "Maximum distance for the pickup sound"
      }
    });

  registerGeneratedPropertyMetadata(HealthPickupComponent, {
      "healAmount": {
        "type": "number",
        "min": 0,
        "step": 1,
        "decimals": 0,
        "description": "Amount of health to restore"
      }
    });

  registerGeneratedPropertyMetadata(PickupSpawnerComponent, {
      "prefabPath": {
        "type": "prefabPath",
        "description": "Path to the prefab to spawn"
      },
      "spawnInterval": {
        "type": "number",
        "min": -1,
        "step": 0.5,
        "decimals": 1,
        "description": "Spawn interval in seconds (-1 for single spawn)"
      },
      "spawnOffset": {
        "type": "vector3",
        "description": "Offset position for spawned pickups"
      },
      "spawnSoundUrl": {
        "type": "audioPath",
        "description": "URL to the spawn sound file"
      },
      "spawnVolume": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.1,
        "decimals": 2,
        "description": "Volume of the spawn sound"
      },
      "spawnMaxDistance": {
        "type": "number",
        "min": 0,
        "step": 1,
        "decimals": 0,
        "description": "Maximum distance for the spawn sound"
      }
    });

  registerGeneratedPropertyMetadata(ProximityInteractableComponent, {
      "proximityRange": {
        "type": "number",
        "min": 0.5,
        "step": 0.1,
        "decimals": 1,
        "description": "Proximity detection range"
      },
      "useKeyPressInteraction": {
        "type": "boolean",
        "description": "Whether interaction requires key press (true) or is automatic on proximity (false)"
      }
    });

  registerGeneratedPropertyMetadata(SwitchComponent, {
      "switchType": {
        "type": "enum",
        "options": [
          "toggle",
          "proximity",
          "button"
        ]
      },
      "initialState": {
        "type": "enum",
        "options": [
          "off",
          "on"
        ]
      }
    });

  registerGeneratedPropertyMetadata(TriggerZoneComponent, {
      "filter": {
        "type": "enum",
        "options": [
          "all",
          "playerOnly",
          "pawnsOnly",
          "custom"
        ]
      },
      "enableStayEvents": {
        "type": "boolean"
      }
    });

  registerGeneratedClassMetadata(DirectionalLightComponent, { description: "Wraps a THREE.DirectionalLight." });
  registerGeneratedPropertyMetadata(DirectionalLightComponent, {
      "shadowCameraLeft": {
        "type": "number",
        "description": "Left bound of the default orthographic shadow frustum"
      },
      "shadowCameraRight": {
        "type": "number",
        "description": "Right bound of the default orthographic shadow frustum"
      },
      "shadowCameraTop": {
        "type": "number",
        "description": "Top bound of the default orthographic shadow frustum"
      },
      "shadowCameraBottom": {
        "type": "number",
        "description": "Bottom bound of the default orthographic shadow frustum"
      },
      "useCsmShadows": {
        "type": "boolean",
        "description": "Use standard shadows for smaller/fixed scenes. Enable CSM for large view distances when you need better distant shadow detail at higher GPU cost. Only one directional light can drive CSM at a time."
      },
      "isSunLight": {
        "type": "boolean",
        "description": "Is this a sun light?"
      },
      "csmCascadeCount": {
        "type": "number",
        "description": "Number of shadow cascades to render (higher costs more)"
      },
      "csmMaxFar": {
        "type": "number",
        "description": "Maximum camera distance covered by cascaded shadows (should be smaller than shadowFar)"
      },
      "csmMode": {
        "type": "enum",
        "options": [
          "practical",
          "uniform",
          "logarithmic"
        ],
        "description": "Cascade split distribution mode"
      },
      "csmLightMargin": {
        "type": "number",
        "description": "Extra margin applied when fitting cascade shadow bounds"
      },
      "csmFade": {
        "type": "boolean",
        "description": "Blend shadow transitions between cascades and near the CSM cutoff"
      }
    });

  registerGeneratedClassMetadata(HemisphereLightComponent, { description: "Wraps a THREE.HemisphereLight.\nNote: Use the inherited `color` property for the sky color (upper hemisphere)." });
  registerGeneratedPropertyMetadata(HemisphereLightComponent, {
      "groundColor": {
        "type": "color",
        "transient": true
      }
    });

  registerGeneratedClassMetadata(LightComponent, { description: "Abstract base class for all light components. Wraps a THREE.Light." });
  registerGeneratedPropertyMetadata(LightComponent, {
      "light": {
        "type": "unknown",
        "hidden": true
      },
      "color": {
        "type": "color",
        "transient": true
      },
      "intensity": {
        "type": "number",
        "transient": true
      },
      "shadowMapSize": {
        "type": "number",
        "description": "Higher resolution for better quality"
      },
      "shadowBias": {
        "type": "number",
        "description": "Conservative negative bias (will be auto-adjusted)"
      },
      "shadowNormalBias": {
        "type": "number",
        "description": "Conservative normal bias (will be auto-adjusted)"
      },
      "shadowNear": {
        "type": "number",
        "description": "Near plane used by each shadow camera (for CSM this applies per cascade)"
      },
      "shadowFar": {
        "type": "number",
        "description": "Far plane used by each shadow camera (for CSM this is separate from csmMaxFar view coverage, should be larger than csmMaxFar)"
      },
      "shadowRadius": {
        "type": "number",
        "description": "Shadow softness radius for PCFShadowMap"
      }
    });

  registerGeneratedPropertyMetadata(LightProbeGridComponent, {
      "cubeMapSize": {
        "type": "number",
        "min": 16,
        "max": 1024
      },
      "probeSize": {
        "type": "number",
        "min": 0.1,
        "max": 2,
        "step": 0.1
      },
      "boundsX": {
        "type": "number",
        "min": 1,
        "max": 200
      },
      "boundsY": {
        "type": "number",
        "min": 1,
        "max": 100
      },
      "boundsZ": {
        "type": "number",
        "min": 1,
        "max": 200
      },
      "countX": {
        "type": "number",
        "min": 2,
        "max": 20,
        "step": 1
      },
      "countY": {
        "type": "number",
        "min": 2,
        "max": 10,
        "step": 1
      },
      "countZ": {
        "type": "number",
        "min": 2,
        "max": 20,
        "step": 1
      },
      "visualizationMode": {
        "type": "enum",
        "options": [
          "none",
          "sh",
          "cubemap"
        ]
      }
    });

  registerGeneratedClassMetadata(PointLightComponent, { description: "Wraps a THREE.PointLight." });
  registerGeneratedPropertyMetadata(PointLightComponent, {
      "distance": {
        "type": "number",
        "transient": true
      },
      "decay": {
        "type": "number",
        "transient": true
      }
    });

  registerGeneratedClassMetadata(RectAreaLightComponent, { description: "Wraps a THREE.RectAreaLight." });
  registerGeneratedPropertyMetadata(RectAreaLightComponent, {
      "width": {
        "type": "number",
        "transient": true
      },
      "height": {
        "type": "number",
        "transient": true
      }
    });

  registerGeneratedClassMetadata(SpotLightComponent, { description: "Wraps a THREE.SpotLight." });
  registerGeneratedPropertyMetadata(SpotLightComponent, {
      "distance": {
        "type": "number",
        "transient": true
      },
      "decay": {
        "type": "number",
        "transient": true
      },
      "angle": {
        "type": "number",
        "transient": true
      },
      "penumbra": {
        "type": "number",
        "transient": true
      }
    });

  registerGeneratedPropertyMetadata(AerialMovementComponent, {
      "maxSpeed": {
        "type": "number"
      },
      "accelerationLambda": {
        "type": "number"
      },
      "decelerationLambda": {
        "type": "number"
      },
      "hoverHeight": {
        "type": "number"
      },
      "hoverVariation": {
        "type": "number"
      },
      "rotationSpeed": {
        "type": "number"
      },
      "maxTiltAngle": {
        "type": "number"
      }
    });

  registerGeneratedPropertyMetadata(AirplaneMovementComponent, {
      "pitchParams": {
        "type": "object",
        "fields": {
          "maxSpeedDPS": {
            "type": "number"
          },
          "accelerationLambda": {
            "type": "number"
          },
          "decelerationLambda": {
            "type": "number"
          },
          "maxDegrees": {
            "type": "number"
          },
          "autoLevelLambda": {
            "type": "number"
          }
        }
      },
      "yawParams": {
        "type": "object",
        "fields": {
          "maxSpeedDPS": {
            "type": "number"
          },
          "accelerationLambda": {
            "type": "number"
          },
          "decelerationLambda": {
            "type": "number"
          },
          "maxDegrees": {
            "type": "number"
          },
          "autoLevelLambda": {
            "type": "number"
          }
        }
      },
      "rollParams": {
        "type": "object",
        "fields": {
          "maxSpeedDPS": {
            "type": "number"
          },
          "accelerationLambda": {
            "type": "number"
          },
          "decelerationLambda": {
            "type": "number"
          },
          "maxDegrees": {
            "type": "number"
          },
          "autoLevelLambda": {
            "type": "number"
          }
        }
      },
      "throttleRate": {
        "type": "number"
      },
      "maxSpeed": {
        "type": "number"
      },
      "minSpeed": {
        "type": "number"
      }
    });

  registerGeneratedClassMetadata(BasePawnMovementComponent, { description: "Base class for all pawn movement components\nProvides abstract methods for handling movement input" });
  registerGeneratedPropertyMetadata(BasePawnMovementComponent, {
      "speedModifier": {
        "type": "number"
      },
      "jumpStrengthModifier": {
        "type": "number"
      },
      "positionCorrectionThreshold": {
        "type": "number",
        "category": "Multiplayer"
      },
      "correctionCooldownInputs": {
        "type": "number",
        "category": "Multiplayer"
      },
      "replicatedAckSequence": {
        "type": "number",
        "replicate": true,
        "transient": true,
        "hidden": true,
        "net": {
          "netType": "int",
          "replicateTo": "owner"
        }
      }
    });

  registerGeneratedPropertyMetadata(CharacterMovementComponent, {
      "maxSpeed": {
        "type": "number"
      },
      "accelerationLambda": {
        "type": "number"
      },
      "decelerationLambda": {
        "type": "number"
      },
      "midAirAccelerationLambda": {
        "type": "number"
      },
      "midAirDecelerationLambda": {
        "type": "number"
      },
      "lookRightSpeed": {
        "type": "number"
      },
      "lookUpSpeed": {
        "type": "number"
      },
      "jumpSpeed": {
        "type": "number"
      },
      "maxMidAirJumps": {
        "type": "number"
      },
      "characterControllerOptions": {
        "type": "object",
        "fields": {
          "offset": {
            "type": "number"
          },
          "simulatedGravityScale": {
            "type": "number"
          },
          "applyImpulsesToDynamicBodies": {
            "type": "boolean"
          },
          "characterMass": {
            "type": "number"
          },
          "slideEnabled": {
            "type": "boolean"
          },
          "maxSlopeClimbAngle": {
            "type": "number"
          },
          "minSlopeSlideAngle": {
            "type": "number"
          },
          "snapToGroundDistance": {
            "type": "number"
          },
          "autoStepConfig": {
            "type": "object",
            "fields": {
              "maxHeight": {
                "type": "number"
              },
              "minWidth": {
                "type": "number"
              },
              "includeDynamicBodies": {
                "type": "boolean"
              }
            }
          }
        }
      },
      "isGrounded": {
        "type": "boolean",
        "replicate": true,
        "transient": true,
        "hidden": true,
        "net": {
          "netType": "bool",
          "replicateTo": "non-owner"
        }
      },
      "forwardVelocity": {
        "type": "number",
        "replicate": true,
        "transient": true,
        "hidden": true,
        "net": {
          "netType": "float",
          "replicateTo": "non-owner",
          "quantization": {
            "mode": "scale",
            "scale": 100
          }
        }
      },
      "rightVelocity": {
        "type": "number",
        "replicate": true,
        "transient": true,
        "hidden": true,
        "net": {
          "netType": "float",
          "replicateTo": "non-owner",
          "quantization": {
            "mode": "scale",
            "scale": 100
          }
        }
      },
      "verticalVelocity": {
        "type": "number",
        "replicate": true,
        "transient": true,
        "hidden": true,
        "net": {
          "netType": "float",
          "replicateTo": "non-owner",
          "quantization": {
            "mode": "scale",
            "scale": 100
          }
        }
      }
    });

  registerGeneratedPropertyMetadata(PathMovementComponent, {
      "path": {
        "type": "vector3"
      },
      "speed": {
        "type": "number"
      },
      "loop": {
        "type": "enum",
        "options": [
          "NoLoop",
          "Loop",
          "PingPong"
        ]
      },
      "autoStart": {
        "type": "boolean"
      }
    });

  registerGeneratedPropertyMetadata(SpectatorMovementComponent, {
      "maxSpeed": {
        "type": "number"
      },
      "minSpeed": {
        "type": "number",
        "min": 0.1
      },
      "maxSpeedCap": {
        "type": "number",
        "min": 1
      },
      "scrollSpeedFactor": {
        "type": "number",
        "min": 1.01,
        "step": 0.05,
        "decimals": 2
      },
      "accelerationLambda": {
        "type": "number"
      },
      "decelerationLambda": {
        "type": "number"
      },
      "lookSpeed": {
        "type": "number"
      },
      "lookSpeedContinuous": {
        "type": "number"
      },
      "minPitchAngle": {
        "type": "number"
      },
      "maxPitchAngle": {
        "type": "number"
      }
    });

  registerGeneratedPropertyMetadata(SpringArmComponent, {
      "collisionBuffer": {
        "type": "number",
        "min": 0,
        "step": 0.01,
        "decimals": 3
      },
      "pivotOffset": {
        "type": "vector3"
      },
      "armLength": {
        "type": "number",
        "min": 0
      },
      "springBackLambda": {
        "type": "number",
        "min": 0,
        "step": 0.1,
        "decimals": 2
      },
      "collisionEnabled": {
        "type": "boolean"
      }
    });

  registerGeneratedPropertyMetadata(TopDownMovementComponent, {
      "panSpeed": {
        "type": "number"
      },
      "zoomSpeed": {
        "type": "number"
      },
      "invertPan": {
        "type": "boolean"
      }
    });

  registerGeneratedPropertyMetadata(TweenMovementComponent, {
      "duration": {
        "type": "number",
        "min": 0,
        "step": 0.1
      },
      "targetPosition": {
        "type": "vector3"
      },
      "targetRotation": {
        "type": "vector3"
      },
      "targetScale": {
        "type": "vector3"
      },
      "easing": {
        "type": "enum",
        "options": [
          "Linear",
          "Quadratic.In",
          "Quadratic.Out",
          "Quadratic.InOut",
          "Cubic.In",
          "Cubic.Out",
          "Cubic.InOut",
          "Quartic.In",
          "Quartic.Out",
          "Quartic.InOut",
          "Quintic.In",
          "Quintic.Out",
          "Quintic.InOut",
          "Sinusoidal.In",
          "Sinusoidal.Out",
          "Sinusoidal.InOut",
          "Exponential.In",
          "Exponential.Out",
          "Exponential.InOut",
          "Circular.In",
          "Circular.Out",
          "Circular.InOut",
          "Elastic.In",
          "Elastic.Out",
          "Elastic.InOut",
          "Back.In",
          "Back.Out",
          "Back.InOut",
          "Bounce.In",
          "Bounce.Out",
          "Bounce.InOut"
        ]
      },
      "loop": {
        "type": "enum",
        "options": [
          "NoLoop",
          "Loop"
        ]
      },
      "autoStart": {
        "type": "boolean"
      }
    });

  registerGeneratedPropertyMetadata(VehicleMovementComponent, {
      "maxEnginePower": {
        "type": "number"
      },
      "maxSteeringAngle": {
        "type": "number"
      },
      "maxBrakeForce": {
        "type": "number"
      },
      "engineResponseRate": {
        "type": "number"
      },
      "steeringResponseRate": {
        "type": "number"
      },
      "brakeResponseRate": {
        "type": "number"
      },
      "wheels": {
        "type": "array",
        "child": {
          "type": "object",
          "fields": {
            "position": {
              "type": "vector3"
            },
            "radius": {
              "type": "number"
            },
            "width": {
              "type": "number"
            },
            "canSteer": {
              "type": "boolean"
            },
            "isPowered": {
              "type": "boolean"
            },
            "canBrake": {
              "type": "boolean"
            },
            "suspensionRestLength": {
              "type": "number"
            },
            "suspensionStiffness": {
              "type": "number"
            },
            "suspensionCompression": {
              "type": "number"
            },
            "suspensionRelaxation": {
              "type": "number"
            },
            "maxSuspensionForce": {
              "type": "number"
            },
            "maxSuspensionTravel": {
              "type": "number"
            },
            "sideFrictionStiffness": {
              "type": "number"
            },
            "frictionSlip": {
              "type": "number"
            },
            "wheelDirection": {
              "type": "vector3"
            },
            "wheelAxle": {
              "type": "vector3"
            }
          }
        }
      },
      "createWheelMeshes": {
        "type": "boolean"
      },
      "wheelMaterialColor": {
        "type": "number"
      },
      "autoBreakWhenNotPossessed": {
        "type": "number"
      },
      "autoStopBreak": {
        "type": "number"
      }
    });

  registerGeneratedPropertyMetadata(AnimationStateMachineComponent, {
      "configUrl": {
        "type": "string",
        "required": true
      }
    });

  registerGeneratedPropertyMetadata(BaseInstancedMeshComponent, {
      "maxInstances": {
        "type": "number"
      },
      "uvScaleTilesPerUnit": {
        "type": "number"
      },
      "instances": {
        "type": "array",
        "child": {
          "type": "object",
          "fields": {
            "position": {
              "type": "vector3"
            },
            "rotation": {
              "type": "euler"
            },
            "scale": {
              "type": "vector3"
            }
          }
        },
        "hidden": true
      },
      "isWorldSpace": {
        "type": "boolean"
      },
      "colors": {},
      "updatePhysicsOnInstanceTransform": {
        "type": "boolean"
      },
      "instanceScale": {
        "type": "vector3"
      },
      "instanceRotation": {
        "type": "vector3"
      },
      "instanceOffset": {
        "type": "vector3"
      },
      "instanceDensity": {
        "type": "number"
      },
      "instanceScaleDelta": {
        "type": "number"
      },
      "instanceRotationDelta": {
        "type": "vector3"
      },
      "instanceOffsetDelta": {
        "type": "vector3"
      },
      "cullDistance": {
        "type": "number"
      },
      "perInstanceFrustumCulling": {
        "type": "boolean"
      }
    });

  registerGeneratedPropertyMetadata(BillboardComponent, {
      "imageUrl": {
        "type": "texturePath",
        "required": true,
        "description": "Image URL"
      },
      "depthTest": {
        "type": "boolean"
      },
      "depthWrite": {
        "type": "boolean"
      },
      "transparent": {
        "type": "boolean"
      },
      "toneMapped": {
        "type": "boolean"
      }
    });

  registerGeneratedPropertyMetadata(FogComponent, {
      "fogMode": {
        "type": "enum",
        "options": [
          "linear",
          "exponential"
        ]
      },
      "fogColor": {
        "type": "color"
      },
      "fogNear": {
        "type": "number",
        "min": 0,
        "step": 0.1,
        "decimals": 1,
        "description": "Near distance for linear fog"
      },
      "fogFar": {
        "type": "number",
        "min": 0,
        "step": 1,
        "decimals": 0,
        "description": "Far distance for linear fog"
      },
      "fogDensity": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.01,
        "decimals": 3,
        "description": "Density for exponential fog"
      }
    });

  registerGeneratedPropertyMetadata(InstancedMeshComponent, {
      "geometry": {
        "type": "bufferGeometry"
      },
      "modelMaterial": {
        "type": "materialPath"
      },
      "lods": {
        "type": "array",
        "child": {
          "type": "object",
          "fields": {
            "geometry": {
              "type": "bufferGeometry"
            },
            "distance": {
              "type": "number"
            }
          }
        }
      }
    });

  registerGeneratedPropertyMetadata(InstancedModelMeshComponent, {
      "modelUrl": {
        "type": "modelPath",
        "required": true,
        "description": "Model URL"
      },
      "modelMaterial": {
        "type": "materialPath"
      },
      "modelMaterials": {
        "type": "array",
        "child": {
          "type": "materialPath"
        }
      },
      "lods": {
        "type": "array",
        "child": {
          "type": "object",
          "fields": {
            "modelUrl": {
              "type": "string"
            },
            "distance": {
              "type": "number"
            }
          }
        }
      }
    });

  registerGeneratedPropertyMetadata(MeshComponent, {
      "uvScaleTilesPerUnit": {
        "type": "number"
      },
      "geometry": {
        "type": "bufferGeometry"
      },
      "material": {
        "type": "materialPath",
        "migrateFrom": "meshMaterial"
      }
    });

  registerGeneratedPropertyMetadata(MeshSocket, {
      "name": {
        "type": "string"
      },
      "boneName": {
        "type": "enum",
        "selector": "getAvailableBones"
      },
      "offsetLocation": {
        "type": "vector3"
      },
      "offsetRotation": {
        "type": "euler"
      },
      "offsetScale": {
        "type": "vector3",
        "initialValue": {
          "x": 1,
          "y": 1,
          "z": 1
        }
      }
    });

  registerGeneratedPropertyMetadata(ModelMeshComponent, {
      "modelUrl": {
        "type": "modelPath",
        "required": true,
        "description": "Model URL"
      },
      "modelMaterial": {
        "type": "materialPath"
      },
      "modelMaterials": {
        "type": "array",
        "child": {
          "type": "materialPath"
        }
      },
      "useDynamicMaterials": {
        "type": "boolean"
      },
      "sockets": {
        "type": "array",
        "child": {
          "type": "object",
          "fields": {
            "name": {
              "type": "string"
            },
            "boneName": {
              "type": "enum",
              "selector": "getAvailableBones"
            },
            "offsetLocation": {
              "type": "vector3"
            },
            "offsetRotation": {
              "type": "euler"
            },
            "offsetScale": {
              "type": "vector3",
              "initialValue": {
                "x": 1,
                "y": 1,
                "z": 1
              }
            }
          }
        }
      },
      "useBundleGroup": {
        "type": "boolean",
        "description": "Whether to bundle the model into a single render bundle (WebGPU only)"
      }
    });

  registerGeneratedPropertyMetadata(SceneEnvironmentComponent, {
      "sourceType": {
        "type": "enum",
        "options": [
          "Textured",
          "Procedural"
        ],
        "migrateFrom": "skyboxType"
      },
      "textureUrl": {
        "type": "hdriPath"
      },
      "backgroundIntensity": {
        "type": "number",
        "min": 0
      },
      "backgroundBlurriness": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.1
      },
      "backgroundRotation": {
        "type": "euler"
      },
      "envMapIntensity": {
        "type": "number",
        "min": 0
      },
      "envMapRotation": {
        "type": "euler"
      },
      "width": {
        "type": "number"
      },
      "height": {
        "type": "number"
      },
      "bottomColor": {
        "type": "color"
      },
      "middleColor": {
        "type": "color"
      },
      "topColor": {
        "type": "color"
      }
    });

  registerGeneratedClassMetadata(SkyComponent, { description: "Procedural atmospheric sky component supporting WebGL and WebGPU." });
  registerGeneratedPropertyMetadata(SkyComponent, {
      "turbidity": {
        "type": "number",
        "min": 0,
        "max": 20,
        "step": 0.1,
        "description": "Atmospheric turbidity (haziness)"
      },
      "rayleigh": {
        "type": "number",
        "min": 0,
        "max": 4,
        "step": 0.1,
        "description": "Rayleigh scattering intensity"
      },
      "mieCoefficient": {
        "type": "number",
        "min": 0,
        "max": 0.1,
        "step": 0.001,
        "description": "Mie scattering coefficient"
      },
      "mieDirectionalG": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.01,
        "description": "Mie directional g (scattering directionality)"
      },
      "sunPosition": {
        "type": "vector3",
        "description": "Sun position direction, ignored when there is a sun light in the scene"
      },
      "cloudScale": {
        "type": "number",
        "min": 0.00001,
        "max": 0.001,
        "step": 0.00001,
        "description": "Cloud pattern scale"
      },
      "cloudSpeed": {
        "type": "number",
        "min": 0,
        "max": 0.01,
        "step": 0.0001,
        "description": "Cloud animation speed"
      },
      "cloudCoverage": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.05,
        "description": "Cloud coverage amount (0 = no clouds)"
      },
      "cloudDensity": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.05,
        "description": "Cloud density/opacity"
      },
      "cloudElevation": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.05,
        "description": "Cloud elevation height (0 = horizon, 1 = overhead)"
      },
      "showSunDisc": {
        "type": "boolean",
        "description": "Show sun disc (disable for environment map generation)"
      },
      "generateEnvironmentMap": {
        "type": "boolean",
        "description": "Whether to generate environment map from sky and apply it to the scene (default: false)"
      },
      "environmentMapIntensity": {
        "type": "number",
        "min": 0,
        "max": 10,
        "step": 0.1,
        "description": "Intensity of the environment map"
      }
    });

  registerGeneratedPropertyMetadata(SplineMeshComponent, {
      "points": {
        "type": "array",
        "child": {
          "type": "vector3"
        }
      },
      "width": {
        "type": "number",
        "min": 0.1,
        "max": 100,
        "step": 0.1,
        "decimals": 2
      },
      "segments": {
        "type": "number",
        "min": 2,
        "max": 500,
        "step": 1
      },
      "closed": {
        "type": "boolean"
      },
      "tension": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.05,
        "decimals": 2
      },
      "uvScale": {
        "type": "number",
        "min": 0.01,
        "max": 10,
        "step": 0.1,
        "decimals": 2
      },
      "materialPath": {
        "type": "materialPath"
      },
      "showDebug": {
        "type": "boolean"
      }
    });

  registerGeneratedPropertyMetadata(TerrainMeshComponent, {
      "width": {
        "type": "number"
      },
      "depth": {
        "type": "number"
      },
      "widthSegments": {
        "type": "number"
      },
      "depthSegments": {
        "type": "number"
      },
      "maxHeight": {
        "type": "number"
      },
      "terrainMaterial": {
        "type": "materialPath"
      },
      "noiseType": {
        "type": "enum",
        "options": [
          "random",
          "perlin"
        ]
      },
      "noiseFrequency": {
        "type": "number"
      },
      "noiseSeed": {
        "type": "number"
      },
      "uvScaleTilesPerUnit": {
        "type": "number"
      }
    });

  registerGeneratedPropertyMetadata(TextComponent, {
      "text": {
        "type": "string"
      },
      "fontSize": {
        "type": "number",
        "min": 8,
        "max": 128,
        "step": 1
      },
      "fontFamily": {
        "type": "string"
      },
      "fontWeight": {
        "type": "string"
      },
      "textColor": {
        "type": "string"
      },
      "backgroundColor": {
        "type": "string"
      },
      "backgroundOpacity": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.1,
        "decimals": 2
      },
      "padding": {
        "type": "number",
        "min": 0,
        "max": 100,
        "step": 1
      },
      "borderRadius": {
        "type": "number",
        "min": 0,
        "max": 50,
        "step": 1
      },
      "canvasWidth": {
        "type": "number",
        "min": 64,
        "max": 2048,
        "step": 64
      },
      "canvasHeight": {
        "type": "number",
        "min": 32,
        "max": 1024,
        "step": 32
      },
      "depthTest": {
        "type": "boolean"
      },
      "depthWrite": {
        "type": "boolean"
      }
    });

  registerGeneratedPropertyMetadata(UI3DComponent, {
      "screenMargin": {
        "type": "number"
      },
      "hideWhenBehindCamera": {
        "type": "boolean"
      },
      "clampToScreenBounds": {
        "type": "boolean"
      },
      "screenOffset": {
        "type": "object",
        "fields": {
          "x": {
            "type": "number"
          },
          "y": {
            "type": "number"
          }
        }
      },
      "distanceScaling": {
        "type": "object",
        "fields": {
          "baseDistance": {
            "type": "number"
          },
          "minScale": {
            "type": "number"
          },
          "maxScale": {
            "type": "number"
          }
        }
      }
    });

  registerGeneratedClassMetadata(VoxelMeshComponent, { description: "VoxelMeshComponent - renders voxel-based meshes.\nSet `voxPath` to a `.vox` file to load it automatically in both editor and runtime.\nUse `paletteOverrides` to tint individual palette indices without editing the source file." });
  registerGeneratedPropertyMetadata(VoxelMeshComponent, {
      "voxPath": {
        "type": "voxelPath",
        "required": true,
        "description": "MagicaVoxel .vox file path"
      },
      "voxelSize": {
        "type": "number",
        "min": 0.01,
        "step": 0.1,
        "decimals": 3,
        "description": "World units per voxel"
      },
      "paletteOverrides": {
        "type": "array",
        "child": {
          "type": "object",
          "fields": {
            "index": {
              "type": "number",
              "min": 1,
              "max": 255,
              "step": 1,
              "decimals": 0
            },
            "color": {
              "type": "color"
            }
          }
        },
        "description": "Per-index color overrides (index = 1-based MagicaVoxel palette index)"
      }
    });

  registerGeneratedClassMetadata(BehaviorTreeComponent, { description: "Component that manages and executes a behavior tree for an NPC.\nThis is the main component that should be attached to NPCs that need AI behavior." });
  registerGeneratedPropertyMetadata(BehaviorTreeComponent, {
      "updateInterval": {
        "type": "number"
      },
      "autoStart": {
        "type": "boolean"
      },
      "behaviorTreePath": {
        "type": "jsonPath"
      }
    });

  registerGeneratedPropertyMetadata(CanvasUIComponent, {
      "panelSize": {
        "type": "object",
        "fields": {
          "width": {
            "type": "number"
          },
          "height": {
            "type": "number"
          }
        }
      },
      "canvasSize": {
        "type": "object",
        "fields": {
          "width": {
            "type": "number"
          },
          "height": {
            "type": "number"
          }
        }
      },
      "opacity": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.1
      },
      "content": {
        "type": "unknown"
      },
      "uiConfig": {
        "type": "object",
        "fields": {
          "panelSize": {
            "type": "object",
            "fields": {
              "width": {
                "type": "number"
              },
              "height": {
                "type": "number"
              }
            }
          },
          "width": {
            "type": "number"
          },
          "height": {
            "type": "number"
          },
          "opacity": {
            "type": "number"
          },
          "body": {
            "type": "object",
            "fields": {
              "fontFamily": {
                "type": "string"
              },
              "fontWeight": {
                "type": "string"
              },
              "fontSize": {
                "type": "number"
              },
              "padding": {
                "type": "number"
              },
              "backgroundColor": {
                "type": "string"
              },
              "fontColor": {
                "type": "string"
              },
              "borderRadius": {
                "type": "number"
              },
              "type": {
                "type": "enum",
                "options": [
                  "text",
                  "button",
                  "image",
                  "shape",
                  "input-text",
                  "picker",
                  "slider",
                  "img"
                ]
              },
              "position": {
                "type": "object",
                "fields": {
                  "x": {
                    "type": "number"
                  },
                  "y": {
                    "type": "number"
                  },
                  "left": {
                    "type": "number"
                  },
                  "right": {
                    "type": "number"
                  },
                  "top": {
                    "type": "number"
                  },
                  "bottom": {
                    "type": "number"
                  }
                }
              },
              "width": {
                "type": "number"
              },
              "height": {
                "type": "number"
              },
              "overflow": {
                "type": "enum",
                "options": [
                  "fit",
                  "scroll",
                  "hidden"
                ]
              },
              "textAlign": {
                "type": "enum",
                "options": [
                  "center",
                  "left",
                  "right"
                ]
              },
              "verticalAlign": {
                "type": "enum",
                "options": [
                  "top",
                  "middle",
                  "bottom"
                ]
              },
              "paddingTop": {
                "type": "number"
              },
              "paddingLeft": {
                "type": "number"
              },
              "paddingBottom": {
                "type": "number"
              },
              "paddingRight": {
                "type": "number"
              },
              "clipPath": {
                "type": "string"
              },
              "border": {
                "type": "string"
              },
              "hover": {
                "type": "string"
              },
              "active": {
                "type": "string"
              },
              "display": {
                "type": "enum",
                "options": [
                  "none",
                  "block"
                ]
              },
              "scrollY": {
                "type": "number"
              },
              "minScrollY": {
                "type": "number"
              },
              "leading": {
                "type": "number"
              },
              "min": {
                "type": "number"
              },
              "max": {
                "type": "number"
              },
              "onSelect": {
                "type": "unknown"
              },
              "onEnter": {
                "type": "unknown"
              },
              "onChanged": {
                "type": "unknown"
              },
              "onChange": {
                "type": "unknown"
              },
              "picker": {
                "type": "color"
              },
              "slider": {
                "type": "object",
                "fields": {
                  "min": {
                    "type": "number"
                  },
                  "max": {
                    "type": "number"
                  },
                  "value": {
                    "type": "number"
                  },
                  "bar": {
                    "type": "boolean"
                  },
                  "needsUpdate": {
                    "type": "boolean"
                  },
                  "onChange": {
                    "type": "unknown"
                  },
                  "canvasui": {
                    "type": "unknown"
                  },
                  "slider": {
                    "type": "object",
                    "fields": {
                      "x": {
                        "type": "number"
                      },
                      "y": {
                        "type": "number"
                      },
                      "width": {
                        "type": "number"
                      },
                      "height": {
                        "type": "number"
                      },
                      "font": {
                        "type": "string"
                      }
                    }
                  },
                  "text": {
                    "type": "object",
                    "fields": {
                      "x": {
                        "type": "number"
                      },
                      "y": {
                        "type": "number"
                      },
                      "width": {
                        "type": "number"
                      },
                      "height": {
                        "type": "number"
                      },
                      "font": {
                        "type": "string"
                      }
                    }
                  },
                  "init": {
                    "type": "unknown"
                  },
                  "setValueFromPos": {
                    "type": "unknown"
                  },
                  "drawSlider": {
                    "type": "unknown"
                  },
                  "update": {
                    "type": "unknown"
                  }
                }
              },
              "img": {
                "type": "unknown"
              }
            }
          },
          "scene": {
            "type": "unknown"
          },
          "renderer": {
            "type": "unknown"
          }
        }
      },
      "enableVRInteraction": {
        "type": "boolean"
      },
      "enableHeadTracking": {
        "type": "boolean"
      },
      "headTrackingOffset": {
        "type": "vector3"
      },
      "headTrackingRotation": {
        "type": "euler"
      },
      "blockInteractionsBehind": {
        "type": "boolean"
      },
      "enableDebugCubes": {
        "type": "boolean"
      }
    });

  registerGeneratedPropertyMetadata(VRGrabbableComponent, {
      "vrAttachmentInputType": {
        "type": "enum",
        "options": [
          "grip",
          "select"
        ]
      },
      "hideController": {
        "type": "boolean"
      },
      "attachmentMode": {
        "type": "enum",
        "options": [
          "hand",
          "beam"
        ]
      },
      "offsetPosition": {
        "type": "vector3"
      },
      "offsetRotation": {
        "type": "euler"
      },
      "offsetScale": {
        "type": "vector3"
      },
      "useBeamPickupDistance": {
        "type": "boolean"
      },
      "beamPickupDistance": {
        "type": "number"
      }
    });

  registerGeneratedPropertyMetadata(VRInteractableComponent, {
      "vrInteractionRange": {
        "type": "number"
      },
      "vrInteractionButton": {
        "type": "enum",
        "options": [
          "Trigger",
          "Squeeze",
          "Touchpad",
          "Thumbstick"
        ]
      }
    });

  registerGeneratedPropertyMetadata(VRInteractComponent, {
      "button": {
        "type": "enum",
        "options": [
          "Trigger",
          "Squeeze",
          "Touchpad",
          "Thumbstick"
        ]
      },
      "handedness": {
        "type": "enum",
        "options": [
          "left",
          "right",
          "any"
        ]
      }
    });

  registerGeneratedPropertyMetadata(VRSnapTurnComponent, {
      "angleDeg": {
        "type": "number",
        "min": 1,
        "max": 180,
        "step": 1,
        "unit": "deg"
      },
      "threshold": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.01
      },
      "cooldownMs": {
        "type": "number",
        "min": 0,
        "max": 2000,
        "step": 10,
        "unit": "ms"
      },
      "axis": {
        "type": "enum",
        "options": [
          "TouchpadX",
          "TouchpadY",
          "ThumbstickX",
          "ThumbstickY"
        ]
      },
      "handedness": {
        "type": "enum",
        "options": [
          "left",
          "right",
          "any"
        ]
      }
    });

  registerGeneratedPropertyMetadata(VRTeleportComponent, {
      "axis": {
        "type": "enum",
        "options": [
          "TouchpadX",
          "TouchpadY",
          "ThumbstickX",
          "ThumbstickY"
        ]
      },
      "startThreshold": {
        "type": "number",
        "min": -1,
        "max": 1,
        "step": 0.01
      },
      "releaseThreshold": {
        "type": "number",
        "min": -1,
        "max": 1,
        "step": 0.01
      },
      "handedness": {
        "type": "enum",
        "options": [
          "left",
          "right",
          "any"
        ]
      },
      "maxDistance": {
        "type": "number"
      }
    });

  registerGeneratedClassMetadata(ColorGradientNodeMaterialAsset, { description: "Vertical object-space gradient between two colors on `MeshBasicNodeMaterial`." });
  registerGeneratedPropertyMetadata(ColorGradientNodeMaterialAsset, {
      "colorBottom": {
        "type": "color",
        "description": "Bottom color (Y = -1)"
      },
      "colorTop": {
        "type": "color",
        "description": "Top color (Y = +1)"
      }
    });

  registerGeneratedClassMetadata(DissolveNodeMaterialAsset, { description: "Noise-driven dissolve with glowing edge on `MeshStandardNodeMaterial`." });
  registerGeneratedPropertyMetadata(DissolveNodeMaterialAsset, {
      "color": {
        "type": "color",
        "description": "Base material color"
      },
      "edgeColor": {
        "type": "color",
        "description": "Edge glow color"
      },
      "speed": {
        "type": "number",
        "min": 0.01,
        "max": 5,
        "step": 0.01,
        "description": "Dissolve cycle speed"
      },
      "roughness": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.01,
        "description": "Roughness"
      }
    });

  registerGeneratedClassMetadata(FresnelRimNodeMaterialAsset, { description: "Fresnel rim highlight on `MeshStandardNodeMaterial`: view-dependent edge glow over a dark base." });
  registerGeneratedPropertyMetadata(FresnelRimNodeMaterialAsset, {
      "rimColor": {
        "type": "color",
        "description": "Rim highlight color"
      },
      "baseColor": {
        "type": "color",
        "description": "Base/fill color"
      },
      "power": {
        "type": "number",
        "min": 0.5,
        "max": 10,
        "step": 0.1,
        "description": "Fresnel exponent (sharpness)"
      },
      "emissiveIntensity": {
        "type": "number",
        "min": 0,
        "max": 2,
        "step": 0.05,
        "description": "Emissive intensity of the rim"
      },
      "roughness": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.01,
        "description": "Roughness"
      },
      "metalness": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.01,
        "description": "Metalness"
      }
    });

  registerGeneratedClassMetadata(HeatDistortionNodeMaterialAsset, { description: "Animated heat-haze UV distortion with cool/hot tint on `MeshBasicNodeMaterial`." });
  registerGeneratedPropertyMetadata(HeatDistortionNodeMaterialAsset, {
      "colorCool": {
        "type": "color",
        "description": "Cool color"
      },
      "colorHot": {
        "type": "color",
        "description": "Hot color"
      },
      "speed": {
        "type": "number",
        "min": 0.01,
        "max": 10,
        "step": 0.01,
        "description": "Animation speed"
      },
      "waveFrequency": {
        "type": "number",
        "min": 1,
        "max": 30,
        "step": 0.5,
        "description": "Distortion wave frequency"
      },
      "waveAmplitude": {
        "type": "number",
        "min": 0.001,
        "max": 0.5,
        "step": 0.001,
        "description": "Distortion amplitude"
      }
    });

  registerGeneratedClassMetadata(IridescenceNodeMaterialAsset, { description: "Thin-film iridescence via `MeshPhysicalNodeMaterial` thickness and iridescence controls." });
  registerGeneratedPropertyMetadata(IridescenceNodeMaterialAsset, {
      "color": {
        "type": "color",
        "description": "Diffuse color"
      },
      "roughness": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.01,
        "description": "Roughness"
      },
      "metalness": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.01,
        "description": "Metalness"
      },
      "iridescenceIOR": {
        "type": "number",
        "min": 1,
        "max": 2.5,
        "step": 0.01,
        "description": "Iridescence IOR"
      },
      "iridescenceThickness": {
        "type": "number",
        "min": 100,
        "max": 1200,
        "step": 10,
        "description": "Iridescence thickness (nm)"
      }
    });

  registerGeneratedClassMetadata(MeshBasicNodeMaterialAsset, { description: "WebGPU `MeshBasicNodeMaterial` asset: unlit diffuse tint, serialized for scenes and presets." });
  registerGeneratedPropertyMetadata(MeshBasicNodeMaterialAsset, {
      "color": {
        "type": "color",
        "description": "Diffuse color"
      },
      "aoMapIntensity": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.01,
        "description": "Ambient occlusion map intensity"
      },
      "lightMapIntensity": {
        "type": "number",
        "min": 0,
        "max": 10,
        "step": 0.1,
        "description": "Light map intensity"
      },
      "reflectivity": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.01,
        "description": "Environment reflectivity"
      },
      "refractionRatio": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.01,
        "description": "Refraction ratio"
      },
      "envMapIntensity": {
        "type": "number",
        "min": 0,
        "max": 10,
        "step": 0.1,
        "description": "Environment map intensity"
      },
      "mapPath": {
        "type": "texturePath",
        "description": "Color map path"
      },
      "alphaMapPath": {
        "type": "texturePath",
        "description": "Alpha map path"
      },
      "envMapPath": {
        "type": "texturePath",
        "description": "Environment map path"
      },
      "lightMapPath": {
        "type": "texturePath",
        "description": "Light map path"
      },
      "aoMapPath": {
        "type": "texturePath",
        "description": "Ambient occlusion map path"
      }
    });

  registerGeneratedClassMetadata(MeshLambertNodeMaterialAsset, { description: "WebGPU `MeshLambertNodeMaterial` asset: Lambert diffuse shading with authored color." });
  registerGeneratedPropertyMetadata(MeshLambertNodeMaterialAsset, {
      "color": {
        "type": "color",
        "description": "Diffuse color"
      },
      "emissive": {
        "type": "color",
        "description": "Emissive color"
      },
      "emissiveIntensity": {
        "type": "number",
        "min": 0,
        "max": 10,
        "step": 0.1,
        "description": "Emissive intensity"
      },
      "aoMapIntensity": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.01,
        "description": "Ambient occlusion map intensity"
      },
      "lightMapIntensity": {
        "type": "number",
        "min": 0,
        "max": 10,
        "step": 0.1,
        "description": "Light map intensity"
      },
      "reflectivity": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.01,
        "description": "Environment reflectivity"
      },
      "refractionRatio": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.01,
        "description": "Refraction ratio"
      },
      "envMapIntensity": {
        "type": "number",
        "min": 0,
        "max": 10,
        "step": 0.1,
        "description": "Environment map intensity"
      },
      "mapPath": {
        "type": "texturePath",
        "description": "Color map path"
      },
      "alphaMapPath": {
        "type": "texturePath",
        "description": "Alpha map path"
      },
      "emissiveMapPath": {
        "type": "texturePath",
        "description": "Emissive map path"
      },
      "envMapPath": {
        "type": "texturePath",
        "description": "Environment map path"
      },
      "lightMapPath": {
        "type": "texturePath",
        "description": "Light map path"
      },
      "aoMapPath": {
        "type": "texturePath",
        "description": "Ambient occlusion map path"
      }
    });

  registerGeneratedClassMetadata(MeshMatcapNodeMaterialAsset, { description: "WebGPU `MeshMatcapNodeMaterial` asset: matcap lighting with optional tint." });
  registerGeneratedPropertyMetadata(MeshMatcapNodeMaterialAsset, {
      "color": {
        "type": "color",
        "description": "Tint color"
      },
      "flatShading": {
        "type": "boolean",
        "description": "Enable flat shading"
      },
      "bumpScale": {
        "type": "number",
        "min": -10,
        "max": 10,
        "step": 0.01,
        "description": "Bump map influence"
      },
      "normalScale": {
        "type": "vector2",
        "description": "Normal map influence"
      },
      "normalMapType": {
        "type": "number",
        "description": "Normal map type (`THREE.TangentSpaceNormalMap`, `ObjectSpaceNormalMap`)"
      },
      "mapPath": {
        "type": "texturePath",
        "description": "Color map path"
      },
      "matcapPath": {
        "type": "texturePath",
        "description": "Matcap map path"
      },
      "alphaMapPath": {
        "type": "texturePath",
        "description": "Alpha map path"
      },
      "bumpMapPath": {
        "type": "texturePath",
        "description": "Bump map path"
      },
      "normalMapPath": {
        "type": "texturePath",
        "description": "Normal map path"
      },
      "displacementMapPath": {
        "type": "texturePath",
        "description": "Displacement map path"
      }
    });

  registerGeneratedClassMetadata(MeshNormalNodeMaterialAsset, { description: "WebGPU `MeshNormalNodeMaterial` asset: debug/viewport visualization of mesh normals." });
  registerGeneratedPropertyMetadata(MeshNormalNodeMaterialAsset, {
      "flatShading": {
        "type": "boolean",
        "description": "Enable flat shading"
      },
      "bumpMapPath": {
        "type": "texturePath",
        "description": "Bump map path"
      },
      "normalMapPath": {
        "type": "texturePath",
        "description": "Normal map path"
      },
      "displacementMapPath": {
        "type": "texturePath",
        "description": "Displacement map path"
      }
    });

  registerGeneratedClassMetadata(MeshPhongNodeMaterialAsset, { description: "WebGPU `MeshPhongNodeMaterial` asset: Phong shading with authored diffuse color." });
  registerGeneratedPropertyMetadata(MeshPhongNodeMaterialAsset, {
      "color": {
        "type": "color",
        "description": "Diffuse color"
      },
      "specular": {
        "type": "color",
        "description": "Specular highlight color"
      },
      "shininess": {
        "type": "number",
        "min": 0,
        "max": 200,
        "step": 1,
        "description": "Phong shininess"
      },
      "emissive": {
        "type": "color",
        "description": "Emissive color"
      },
      "emissiveIntensity": {
        "type": "number",
        "min": 0,
        "max": 10,
        "step": 0.1,
        "description": "Emissive intensity"
      },
      "flatShading": {
        "type": "boolean",
        "description": "Enable flat shading"
      },
      "aoMapIntensity": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.01,
        "description": "Ambient occlusion map intensity"
      },
      "lightMapIntensity": {
        "type": "number",
        "min": 0,
        "max": 10,
        "step": 0.1,
        "description": "Light map intensity"
      },
      "reflectivity": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.01,
        "description": "Environment reflectivity"
      },
      "refractionRatio": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.01,
        "description": "Refraction ratio"
      },
      "envMapIntensity": {
        "type": "number",
        "min": 0,
        "max": 10,
        "step": 0.1,
        "description": "Environment map intensity"
      },
      "bumpScale": {
        "type": "number",
        "min": -10,
        "max": 10,
        "step": 0.01,
        "description": "Bump map influence"
      },
      "normalScale": {
        "type": "vector2",
        "description": "Normal map influence"
      },
      "normalMapType": {
        "type": "number",
        "description": "Normal map type (`THREE.TangentSpaceNormalMap`, `ObjectSpaceNormalMap`)"
      },
      "mapPath": {
        "type": "texturePath",
        "description": "Color map path"
      },
      "alphaMapPath": {
        "type": "texturePath",
        "description": "Alpha map path"
      },
      "bumpMapPath": {
        "type": "texturePath",
        "description": "Bump map path"
      },
      "normalMapPath": {
        "type": "texturePath",
        "description": "Normal map path"
      },
      "displacementMapPath": {
        "type": "texturePath",
        "description": "Displacement map path"
      },
      "specularMapPath": {
        "type": "texturePath",
        "description": "Specular map path"
      },
      "emissiveMapPath": {
        "type": "texturePath",
        "description": "Emissive map path"
      },
      "envMapPath": {
        "type": "texturePath",
        "description": "Environment map path"
      },
      "lightMapPath": {
        "type": "texturePath",
        "description": "Light map path"
      },
      "aoMapPath": {
        "type": "texturePath",
        "description": "Ambient occlusion map path"
      }
    });

  registerGeneratedClassMetadata(MeshPhysicalNodeMaterialAsset, { description: "WebGPU `MeshPhysicalNodeMaterial` asset: physical PBR with serialized metal/rough plus transmission and thickness." });
  registerGeneratedPropertyMetadata(MeshPhysicalNodeMaterialAsset, {
      "color": {
        "type": "color",
        "description": "Diffuse color"
      },
      "metalness": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.01,
        "description": "Metalness"
      },
      "roughness": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.01,
        "description": "Roughness"
      },
      "transmission": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.01,
        "description": "Transmission"
      },
      "thickness": {
        "type": "number",
        "min": 0,
        "max": 10,
        "step": 0.1,
        "description": "Thickness"
      },
      "flatShading": {
        "type": "boolean",
        "description": "Enable flat shading"
      },
      "emissive": {
        "type": "color",
        "description": "Emissive color"
      },
      "emissiveIntensity": {
        "type": "number",
        "min": 0,
        "max": 10,
        "step": 0.1,
        "description": "Emissive intensity"
      },
      "clearcoat": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.01,
        "description": "Clearcoat amount"
      },
      "clearcoatRoughness": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.01,
        "description": "Clearcoat roughness"
      },
      "ior": {
        "type": "number",
        "min": 1,
        "max": 2.333,
        "step": 0.01,
        "description": "Index of refraction"
      },
      "iridescence": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.01,
        "description": "Iridescence amount"
      },
      "iridescenceIOR": {
        "type": "number",
        "min": 1,
        "max": 2.333,
        "step": 0.01,
        "description": "Iridescence IOR"
      },
      "sheen": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.01,
        "description": "Sheen amount"
      },
      "sheenColor": {
        "type": "color",
        "description": "Sheen color"
      },
      "sheenRoughness": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.01,
        "description": "Sheen roughness"
      },
      "specularIntensity": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.01,
        "description": "Specular intensity"
      },
      "specularColor": {
        "type": "color",
        "description": "Specular color"
      },
      "anisotropy": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.01,
        "description": "Anisotropy amount"
      },
      "anisotropyRotation": {
        "type": "number",
        "min": 0,
        "step": 0.01,
        "description": "Anisotropy rotation in radians"
      },
      "attenuationColor": {
        "type": "color",
        "description": "Attenuation color"
      },
      "attenuationDistance": {
        "type": "number",
        "min": 0,
        "max": 1000,
        "step": 0.1,
        "description": "Attenuation distance"
      },
      "aoMapIntensity": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.01,
        "description": "Ambient occlusion map intensity"
      },
      "lightMapIntensity": {
        "type": "number",
        "min": 0,
        "max": 10,
        "step": 0.1,
        "description": "Light map intensity"
      },
      "reflectivity": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.01,
        "description": "Environment reflectivity"
      },
      "refractionRatio": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.01,
        "description": "Refraction ratio"
      },
      "envMapIntensity": {
        "type": "number",
        "min": 0,
        "max": 10,
        "step": 0.1,
        "description": "Environment map intensity"
      },
      "bumpScale": {
        "type": "number",
        "min": -10,
        "max": 10,
        "step": 0.01,
        "description": "Bump map influence"
      },
      "normalScale": {
        "type": "vector2",
        "description": "Normal map influence"
      },
      "normalMapType": {
        "type": "number",
        "description": "Normal map type (`THREE.TangentSpaceNormalMap`, `ObjectSpaceNormalMap`)"
      },
      "mapPath": {
        "type": "texturePath",
        "description": "Color map path"
      },
      "alphaMapPath": {
        "type": "texturePath",
        "description": "Alpha map path"
      },
      "roughnessMapPath": {
        "type": "texturePath",
        "description": "Roughness map path"
      },
      "metalnessMapPath": {
        "type": "texturePath",
        "description": "Metalness map path"
      },
      "normalMapPath": {
        "type": "texturePath",
        "description": "Normal map path"
      },
      "bumpMapPath": {
        "type": "texturePath",
        "description": "Bump map path"
      },
      "displacementMapPath": {
        "type": "texturePath",
        "description": "Displacement map path"
      },
      "emissiveMapPath": {
        "type": "texturePath",
        "description": "Emissive map path"
      },
      "clearcoatMapPath": {
        "type": "texturePath",
        "description": "Clearcoat map path"
      },
      "clearcoatRoughnessMapPath": {
        "type": "texturePath",
        "description": "Clearcoat roughness map path"
      },
      "clearcoatNormalMapPath": {
        "type": "texturePath",
        "description": "Clearcoat normal map path"
      },
      "transmissionMapPath": {
        "type": "texturePath",
        "description": "Transmission map path"
      },
      "thicknessMapPath": {
        "type": "texturePath",
        "description": "Thickness map path"
      },
      "sheenColorMapPath": {
        "type": "texturePath",
        "description": "Sheen color map path"
      },
      "sheenRoughnessMapPath": {
        "type": "texturePath",
        "description": "Sheen roughness map path"
      },
      "iridescenceMapPath": {
        "type": "texturePath",
        "description": "Iridescence map path"
      },
      "iridescenceThicknessMapPath": {
        "type": "texturePath",
        "description": "Iridescence thickness map path"
      },
      "specularIntensityMapPath": {
        "type": "texturePath",
        "description": "Specular intensity map path"
      },
      "specularColorMapPath": {
        "type": "texturePath",
        "description": "Specular color map path"
      },
      "envMapPath": {
        "type": "texturePath",
        "description": "Environment map path"
      },
      "aoMapPath": {
        "type": "texturePath",
        "description": "Ambient occlusion map path"
      },
      "lightMapPath": {
        "type": "texturePath",
        "description": "Light map path"
      }
    });

  registerGeneratedClassMetadata(MeshStandardNodeMaterialAsset, { description: "WebGPU `MeshStandardNodeMaterial` asset: metal/rough PBR with serialized metalness and roughness." });
  registerGeneratedPropertyMetadata(MeshStandardNodeMaterialAsset, {
      "color": {
        "type": "color",
        "description": "Diffuse color"
      },
      "metalness": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.01,
        "description": "Metalness"
      },
      "roughness": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.01,
        "description": "Roughness"
      },
      "flatShading": {
        "type": "boolean",
        "description": "Enable flat shading"
      },
      "emissive": {
        "type": "color",
        "description": "Emissive color"
      },
      "emissiveIntensity": {
        "type": "number",
        "min": 0,
        "max": 10,
        "step": 0.1,
        "description": "Emissive intensity"
      },
      "aoMapIntensity": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.01,
        "description": "Ambient occlusion map intensity"
      },
      "lightMapIntensity": {
        "type": "number",
        "min": 0,
        "max": 10,
        "step": 0.1,
        "description": "Light map intensity"
      },
      "reflectivity": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.01,
        "description": "Environment reflectivity"
      },
      "refractionRatio": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.01,
        "description": "Refraction ratio"
      },
      "envMapIntensity": {
        "type": "number",
        "min": 0,
        "max": 10,
        "step": 0.1,
        "description": "Environment map intensity"
      },
      "bumpScale": {
        "type": "number",
        "min": -10,
        "max": 10,
        "step": 0.01,
        "description": "Bump map influence"
      },
      "normalScale": {
        "type": "vector2",
        "description": "Normal map influence"
      },
      "normalMapType": {
        "type": "number",
        "description": "Normal map type (`THREE.TangentSpaceNormalMap`, `ObjectSpaceNormalMap`)"
      },
      "mapPath": {
        "type": "texturePath",
        "description": "Color map path"
      },
      "alphaMapPath": {
        "type": "texturePath",
        "description": "Alpha map path"
      },
      "roughnessMapPath": {
        "type": "texturePath",
        "description": "Roughness map path"
      },
      "metalnessMapPath": {
        "type": "texturePath",
        "description": "Metalness map path"
      },
      "normalMapPath": {
        "type": "texturePath",
        "description": "Normal map path"
      },
      "bumpMapPath": {
        "type": "texturePath",
        "description": "Bump map path"
      },
      "displacementMapPath": {
        "type": "texturePath",
        "description": "Displacement map path"
      },
      "emissiveMapPath": {
        "type": "texturePath",
        "description": "Emissive map path"
      },
      "aoMapPath": {
        "type": "texturePath",
        "description": "Ambient occlusion map path"
      },
      "envMapPath": {
        "type": "texturePath",
        "description": "Environment map path"
      },
      "lightMapPath": {
        "type": "texturePath",
        "description": "Light map path"
      }
    });

  registerGeneratedClassMetadata(MeshToonNodeMaterialAsset, { description: "WebGPU `MeshToonNodeMaterial` asset: stylized toon/cel shading with authored diffuse color." });
  registerGeneratedPropertyMetadata(MeshToonNodeMaterialAsset, {
      "color": {
        "type": "color",
        "description": "Diffuse color"
      },
      "bumpScale": {
        "type": "number",
        "min": -10,
        "max": 10,
        "step": 0.01,
        "description": "Bump map influence"
      },
      "normalScale": {
        "type": "vector2",
        "description": "Normal map influence"
      },
      "normalMapType": {
        "type": "number",
        "description": "Normal map type (`THREE.TangentSpaceNormalMap`, `ObjectSpaceNormalMap`)"
      },
      "mapPath": {
        "type": "texturePath",
        "description": "Color map path"
      },
      "gradientMapPath": {
        "type": "texturePath",
        "description": "Gradient map path"
      },
      "alphaMapPath": {
        "type": "texturePath",
        "description": "Alpha map path"
      },
      "normalMapPath": {
        "type": "texturePath",
        "description": "Normal map path"
      },
      "bumpMapPath": {
        "type": "texturePath",
        "description": "Bump map path"
      },
      "emissiveMapPath": {
        "type": "texturePath",
        "description": "Emissive map path"
      },
      "displacementMapPath": {
        "type": "texturePath",
        "description": "Displacement map path"
      }
    });

  registerGeneratedClassMetadata(NeonPulseNodeMaterialAsset, { description: "Pulsing neon emission stripes on `MeshStandardNodeMaterial`." });
  registerGeneratedPropertyMetadata(NeonPulseNodeMaterialAsset, {
      "color": {
        "type": "color",
        "description": "Base material color"
      },
      "neonColor": {
        "type": "color",
        "description": "Neon emission color"
      },
      "pulseSpeed": {
        "type": "number",
        "min": 0.1,
        "max": 10,
        "step": 0.1,
        "description": "Pulse frequency (Hz)"
      },
      "stripeFrequency": {
        "type": "number",
        "min": 0.1,
        "max": 20,
        "step": 0.1,
        "description": "Stripe frequency along Y"
      },
      "stripeSpeed": {
        "type": "number",
        "min": 0.1,
        "max": 10,
        "step": 0.1,
        "description": "Stripe scroll speed"
      }
    });

  registerGeneratedClassMetadata(ParallaxUVNodeMaterialAsset, { description: "Parallax UV overlay matching three.js `webgpu_parallax_uv.html`." });
  registerGeneratedPropertyMetadata(ParallaxUVNodeMaterialAsset, {
      "uvScale": {
        "type": "number",
        "min": 0.01,
        "max": 100,
        "step": 0.01,
        "description": "UV tiling scale"
      },
      "parallaxScale": {
        "type": "number",
        "min": 0,
        "max": 2,
        "step": 0.01,
        "description": "Parallax strength from height map"
      },
      "colorGain": {
        "type": "number",
        "min": 0,
        "max": 20,
        "step": 0.01,
        "description": "Multiplier on blended base color"
      },
      "metalness": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.01,
        "description": "Metalness"
      },
      "topColorUrl": {
        "type": "texturePath",
        "description": "Top layer albedo"
      },
      "roughnessUrl": {
        "type": "texturePath",
        "description": "Roughness map"
      },
      "normalGlUrl": {
        "type": "texturePath",
        "description": "Normal map GL"
      },
      "displacementUrl": {
        "type": "texturePath",
        "description": "Height / displacement map for parallax offset"
      },
      "bottomColorUrl": {
        "type": "texturePath",
        "description": "Bottom layer albedo sampled with parallax UV"
      }
    });

  registerGeneratedClassMetadata(PointsNodeMaterialAsset, { description: "WebGPU `PointsNodeMaterial` asset: point sprites with color and world-space point size." });
  registerGeneratedPropertyMetadata(PointsNodeMaterialAsset, {
      "color": {
        "type": "color",
        "description": "Point color"
      },
      "pointSize": {
        "type": "number",
        "min": 0.001,
        "max": 1,
        "step": 0.001,
        "description": "Point size in world units"
      },
      "sizeAttenuation": {
        "type": "boolean",
        "description": "Use size attenuation with camera distance"
      },
      "mapPath": {
        "type": "texturePath",
        "description": "Point sprite map path"
      },
      "alphaMapPath": {
        "type": "texturePath",
        "description": "Point sprite alpha map path"
      }
    });

  registerGeneratedClassMetadata(SpriteNodeMaterialAsset, { description: "WebGPU `SpriteNodeMaterial` asset: billboard sprites with authored tint color." });
  registerGeneratedPropertyMetadata(SpriteNodeMaterialAsset, {
      "color": {
        "type": "color",
        "description": "Sprite color"
      },
      "rotation": {
        "type": "number",
        "min": 0,
        "step": 0.01,
        "description": "Sprite rotation in radians"
      },
      "sizeAttenuation": {
        "type": "boolean",
        "description": "Use size attenuation with camera distance"
      },
      "mapPath": {
        "type": "texturePath",
        "description": "Sprite map path"
      },
      "alphaMapPath": {
        "type": "texturePath",
        "description": "Sprite alpha map path"
      }
    });

  registerGeneratedClassMetadata(SSSNodeMaterialAsset, { description: "Subsurface-style thickness shading on `MeshPhysicalNodeMaterial` for wax/skin-like surfaces." });
  registerGeneratedPropertyMetadata(SSSNodeMaterialAsset, {
      "color": {
        "type": "color",
        "description": "Base material color"
      },
      "roughness": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.01,
        "description": "Roughness"
      },
      "thicknessDistortion": {
        "type": "number",
        "min": 0.01,
        "max": 1,
        "step": 0.01,
        "description": "Thickness distortion"
      },
      "thicknessAmbient": {
        "type": "number",
        "min": 0.01,
        "max": 5,
        "step": 0.05,
        "description": "Thickness ambient"
      },
      "thicknessAttenuation": {
        "type": "number",
        "min": 0.01,
        "max": 5,
        "step": 0.05,
        "description": "Thickness attenuation"
      },
      "thicknessPower": {
        "type": "number",
        "min": 0.01,
        "max": 16,
        "step": 0.1,
        "description": "Thickness power"
      },
      "thicknessScale": {
        "type": "number",
        "min": 0.01,
        "max": 50,
        "step": 0.1,
        "description": "Thickness scale"
      }
    });

  registerGeneratedClassMetadata(TransmissionNodeMaterialAsset, { description: "Glass-like transmission preset on `MeshPhysicalNodeMaterial` (IOR, thickness, env specular)." });
  registerGeneratedPropertyMetadata(TransmissionNodeMaterialAsset, {
      "color": {
        "type": "color",
        "description": "Base color"
      },
      "transmission": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.01,
        "description": "Transmission"
      },
      "opacity": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.01,
        "description": "Opacity"
      },
      "metalness": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.01,
        "description": "Metalness"
      },
      "roughness": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.01,
        "description": "Roughness"
      },
      "ior": {
        "type": "number",
        "min": 1,
        "max": 2,
        "step": 0.01,
        "description": "Index of refraction (IOR)"
      },
      "thickness": {
        "type": "number",
        "min": 0,
        "max": 5,
        "step": 0.01,
        "description": "Thickness"
      },
      "specularIntensity": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.01,
        "description": "Specular intensity"
      },
      "specularColor": {
        "type": "color",
        "description": "Specular color"
      },
      "envMapIntensity": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.01,
        "description": "Environment map intensity"
      }
    });

  registerGeneratedClassMetadata(VertexWaveNodeMaterialAsset, { description: "Sinusoidal vertex displacement on `MeshStandardNodeMaterial` for simple procedural animation." });
  registerGeneratedPropertyMetadata(VertexWaveNodeMaterialAsset, {
      "frequency": {
        "type": "number",
        "min": 0.1,
        "max": 20,
        "step": 0.1,
        "description": "Wave frequency along X"
      },
      "amplitude": {
        "type": "number",
        "min": 0.001,
        "max": 1,
        "step": 0.001,
        "description": "Wave amplitude"
      },
      "speed": {
        "type": "number",
        "min": 0.01,
        "max": 10,
        "step": 0.01,
        "description": "Animation speed"
      },
      "roughness": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.01,
        "description": "Roughness"
      },
      "metalness": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.01,
        "description": "Metalness"
      }
    });

  registerGeneratedClassMetadata(WorldTriplanarNodeMaterialAsset, { description: "World-space triplanar stripe pattern on `MeshStandardNodeMaterial` for terrain-like shading." });
  registerGeneratedPropertyMetadata(WorldTriplanarNodeMaterialAsset, {
      "colorDark": {
        "type": "color",
        "description": "Dark stripe color"
      },
      "colorLight": {
        "type": "color",
        "description": "Light stripe color"
      },
      "scale": {
        "type": "number",
        "min": 0.1,
        "max": 20,
        "step": 0.1,
        "description": "Stripe scale in world units"
      },
      "roughness": {
        "type": "number",
        "min": 0,
        "max": 1,
        "step": 0.01,
        "description": "Roughness"
      }
    });

  registerGeneratedRpcMetadata(PlayerController, 'requestLoadMap', [
      {
        "netType": "string"
      }
    ]);

  registerGeneratedRpcMetadata(PlayerController, 'notifyMapLoaded', []);

  registerGeneratedRpcMetadata(BasePawnMovementComponent, 'serverReceiveMovementInput', [
      {
        "netType": "uint"
      },
      {
        "netType": "float",
        "quantization": {
          "mode": "scale",
          "scale": 1000
        }
      },
      {
        "netType": "float",
        "quantization": {
          "mode": "scale",
          "scale": 100
        }
      },
      {
        "netType": "float",
        "quantization": {
          "mode": "scale",
          "scale": 100
        }
      },
      {
        "netType": "float",
        "quantization": {
          "mode": "scale",
          "scale": 100
        }
      },
      {
        "netType": "float",
        "quantization": {
          "mode": "scale",
          "scale": 100
        }
      },
      {
        "netType": "float",
        "quantization": {
          "mode": "scale",
          "scale": 100
        }
      },
      {
        "netType": "bool"
      },
      {
        "netType": "bool"
      },
      {
        "netType": "bool"
      },
      {
        "netType": "float",
        "quantization": {
          "mode": "scale",
          "scale": 1000
        }
      },
      {
        "netType": "float",
        "quantization": {
          "mode": "scale",
          "scale": 1000
        }
      },
      {
        "netType": "float",
        "quantization": {
          "mode": "scale",
          "scale": 1000
        }
      }
    ]);

  registerGeneratedRpcMetadata(BasePawnMovementComponent, 'clientCorrectMovement', [
      {
        "netType": "uint"
      },
      {
        "netType": "float",
        "quantization": {
          "mode": "scale",
          "scale": 1000
        }
      },
      {
        "netType": "float",
        "quantization": {
          "mode": "scale",
          "scale": 1000
        }
      },
      {
        "netType": "float",
        "quantization": {
          "mode": "scale",
          "scale": 1000
        }
      },
      {
        "netType": "float",
        "quantization": {
          "mode": "range",
          "min": -3.141592653589793,
          "max": 3.141592653589793,
          "bits": 16
        }
      },
      {
        "netType": "float",
        "quantization": {
          "mode": "range",
          "min": -3.141592653589793,
          "max": 3.141592653589793,
          "bits": 16
        }
      },
      {
        "netType": "float",
        "quantization": {
          "mode": "range",
          "min": -3.141592653589793,
          "max": 3.141592653589793,
          "bits": 16
        }
      },
      {
        "netType": "float",
        "quantization": {
          "mode": "scale",
          "scale": 100
        }
      },
      {
        "netType": "float",
        "quantization": {
          "mode": "scale",
          "scale": 100
        }
      },
      {
        "netType": "float",
        "quantization": {
          "mode": "scale",
          "scale": 100
        }
      },
      {
        "netType": "uint"
      },
      {
        "netType": "uint"
      }
    ]);

}

// Deferred to avoid circular reference issues during module initialization
queueMicrotask(registerMetadata);
